import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConnBoardRegistrationCode: any;
  Date: any;
  IDToken: any;
  RegistrationCode: any;
  Time: any;
};

export type Address = {
  __typename?: "Address";
  blockBuildingName: Scalars["String"];
  municipality: Scalars["String"];
  prefectures: Scalars["String"];
};

export type ApplyForChangeToAdminInput = {
  email: Scalars["String"];
  sub: Scalars["String"];
};

export type AuthToken = {
  __typename?: "AuthToken";
  access_token: Scalars["String"];
  id_token: Scalars["IDToken"];
  refresh_token: Scalars["String"];
  token_type: Scalars["String"];
};

export enum Authority {
  Admin = "admin",
  Member = "member",
}

export type BankBranchOffice = {
  __typename?: "BankBranchOffice";
  bankId: Scalars["Int"];
  branchOfficeCode: Scalars["String"];
  branchOfficeId: Scalars["Int"];
  branchOfficeName?: Maybe<Scalars["String"]>;
  isHeadOfficeOn?: Maybe<Scalars["Boolean"]>;
};

export type BizSolUserInfo = {
  __typename?: "BizSolUserInfo";
  email: Scalars["String"];
  emailVerified: Scalars["Boolean"];
  locale: Scalars["String"];
  option: BizSolUserInfoOption;
  sub: Scalars["ID"];
  userName: Scalars["String"];
  zoneInfo: Scalars["String"];
};

export type BizSolUserInfoOption = {
  __typename?: "BizSolUserInfoOption";
  authority: Scalars["String"];
  companyName: Scalars["String"];
  loginId: Scalars["String"];
};

export enum BizsolState {
  Admin = "admin",
  Master = "master",
  Member = "member",
  Waiting = "waiting",
}

export enum BusinessType {
  Corporate = "corporate",
  Individual = "individual",
}

export type CancelWaitingForConnectToBizsolInput = {
  sub: Scalars["String"];
};

export type CancelWaitingForConnectToBizsolPayload = {
  __typename?: "CancelWaitingForConnectToBizsolPayload";
  result: Scalars["Boolean"];
};

export type ChangeBizsolStateToWaitingInput = {
  sub: Scalars["String"];
};

export type ChangeBizsolStateToWaitingPayload = {
  __typename?: "ChangeBizsolStateToWaitingPayload";
  result: Scalars["Boolean"];
};

export type ChangePasswordInput = {
  newPassword: Scalars["String"];
  oldPassword: Scalars["String"];
};

export type ChangeToAdminInput = {
  token: Scalars["String"];
};

export type ChangeToAdminPayload = {
  __typename?: "ChangeToAdminPayload";
  result: Scalars["Boolean"];
};

export type ChangeToMemberInput = {
  sub: Scalars["String"];
};

export type ChangeToMemberPayload = {
  __typename?: "ChangeToMemberPayload";
  result: Scalars["Boolean"];
};

export type Company = {
  __typename?: "Company";
  blockBuildingName?: Maybe<Scalars["String"]>;
  branchOfficeId: Scalars["Int"];
  businessContent?: Maybe<Scalars["String"]>;
  capital?: Maybe<Scalars["Int"]>;
  companyBusinessType?: Maybe<BusinessType>;
  companyID: Scalars["Int"];
  companyNameStoreName: Scalars["String"];
  companyNameStoreNameKana?: Maybe<Scalars["String"]>;
  corporateNumber?: Maybe<Scalars["String"]>;
  displayCompanyId: Scalars["String"];
  foundationDate?: Maybe<Scalars["String"]>;
  industriesLarge?: Maybe<Scalars["String"]>;
  industriesMiddle?: Maybe<Scalars["String"]>;
  insuranceAgencyCode?: Maybe<Scalars["String"]>;
  insuranceAgencyName?: Maybe<Scalars["String"]>;
  mainUserName?: Maybe<Scalars["String"]>;
  mainUserPhoneNumber?: Maybe<Scalars["String"]>;
  migrationStatus?: Maybe<CompanyMigrationStatus>;
  municipality?: Maybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  postalCode?: Maybe<Scalars["String"]>;
  prefectures?: Maybe<Scalars["String"]>;
  qualifiedInvoiceIssuerRegistrationNumber?: Maybe<Scalars["String"]>;
  representativeBirthDate?: Maybe<Scalars["String"]>;
  representativeEmailAddress?: Maybe<Scalars["String"]>;
  representativeName: Scalars["String"];
  settlementMonth?: Maybe<Scalars["String"]>;
  siteUrl?: Maybe<Scalars["String"]>;
  staffCount?: Maybe<Scalars["String"]>;
  xCompanyId: Scalars["String"];
};

export enum CompanyMigrationStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
}

export type ConnBoardRegistrationToken = {
  __typename?: "ConnBoardRegistrationToken";
  code: Scalars["ConnBoardRegistrationCode"];
  type: RegistrationTokenType;
};

export enum ConnectBoardState {
  Connected = "connected",
  Invalid = "invalid",
}

export type ConnectBoardUserInfo = {
  __typename?: "ConnectBoardUserInfo";
  email: Scalars["String"];
  emailVerified: Scalars["Boolean"];
  locale: Scalars["String"];
  option: ConnectBoardUserInfoOption;
  sub: Scalars["ID"];
  userName: Scalars["String"];
  zoneInfo: Scalars["String"];
};

export type ConnectBoardUserInfoOption = {
  __typename?: "ConnectBoardUserInfoOption";
  authority: Scalars["String"];
  companyName: Scalars["String"];
  loginId: Scalars["String"];
};

export type ConnectToBizsolInput = {
  client_id: Scalars["String"];
  code: Scalars["String"];
  redirect_uri: Scalars["String"];
};

export type ConnectToBizsolPayload = {
  __typename?: "ConnectToBizsolPayload";
  token?: Maybe<AuthToken>;
};

export type ConnectToConnectBoardInput = {
  client_id: Scalars["String"];
  code: Scalars["String"];
  redirect_uri: Scalars["String"];
};

export type ConnectToConnectBoardPayload = {
  __typename?: "ConnectToConnectBoardPayload";
  token?: Maybe<AuthToken>;
};

export type DeleteCompanyUserInput = {
  sub: Scalars["ID"];
};

export type DeleteCompanyUserPayload = {
  __typename?: "DeleteCompanyUserPayload";
  result: Scalars["Boolean"];
};

export type DisconnectFromBizsolInput = {
  sub: Scalars["String"];
};

export type DisconnectFromBizsolPayload = {
  __typename?: "DisconnectFromBizsolPayload";
  result: Scalars["Boolean"];
};

export type EditCompanyInfoInput = {
  blockBuildingName?: InputMaybe<Scalars["String"]>;
  branchOfficeId: Scalars["Int"];
  businessContent?: InputMaybe<Scalars["String"]>;
  capital?: InputMaybe<Scalars["Int"]>;
  companyBusinessType: BusinessType;
  companyNameStoreName: Scalars["String"];
  companyNameStoreNameKana?: InputMaybe<Scalars["String"]>;
  corporateNumber?: InputMaybe<Scalars["String"]>;
  foundationDate?: InputMaybe<Scalars["String"]>;
  industriesLarge?: InputMaybe<Scalars["String"]>;
  industriesMiddle?: InputMaybe<Scalars["String"]>;
  insuranceAgencyCode?: InputMaybe<Scalars["String"]>;
  insuranceAgencyName?: InputMaybe<Scalars["String"]>;
  mainUserName: Scalars["String"];
  mainUserPhoneNumber: Scalars["String"];
  municipality?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  postalCode?: InputMaybe<Scalars["String"]>;
  prefectures?: InputMaybe<Scalars["String"]>;
  qualifiedInvoiceIssuerRegistrationNumber?: InputMaybe<Scalars["String"]>;
  representativeBirthDate?: InputMaybe<Scalars["String"]>;
  representativeEmailAddress?: InputMaybe<Scalars["String"]>;
  representativeName: Scalars["String"];
  settlementMonth?: InputMaybe<Scalars["String"]>;
  siteUrl?: InputMaybe<Scalars["String"]>;
  staffCount?: InputMaybe<Scalars["String"]>;
};

export type EditCompanyInfoPayload = {
  __typename?: "EditCompanyInfoPayload";
  result: Scalars["Boolean"];
};

export type EditCompanyUser = {
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password: Scalars["String"];
};

export type EditCompanyUserInput = {
  sub: Scalars["ID"];
  user: EditCompanyUser;
};

export type EditCompanyUserPayload = {
  __typename?: "EditCompanyUserPayload";
  user: User;
};

export type MigrateCompanyToAegisPayload = {
  __typename?: "MigrateCompanyToAegisPayload";
  totalUsers: Scalars["Int"];
};

export enum MigrationStatus {
  AwaitingPasswordSync = "AWAITING_PASSWORD_SYNC",
  None = "NONE",
  Synced = "SYNCED",
}

export type Mutation = {
  __typename?: "Mutation";
  acceptCompanyWithdrawal: AcceptCompanyWithdrawalPayload;
  applyForChangeToAdmin: Scalars["Boolean"];
  cancelWaitingForConnectToBizsol?: Maybe<CancelWaitingForConnectToBizsolPayload>;
  changeBizsolStateToWaiting: ChangeBizsolStateToWaitingPayload;
  changePassword: Scalars["Boolean"];
  changeToAdmin: ChangeToAdminPayload;
  changeToMember: ChangeToMemberPayload;
  connectToBizsol?: Maybe<ConnectToBizsolPayload>;
  connectToConnectBoard?: Maybe<ConnectToConnectBoardPayload>;
  deleteCompanyUser: DeleteCompanyUserPayload;
  disconnectFromBizsol: DisconnectFromBizsolPayload;
  editCompanyInfo: EditCompanyInfoPayload;
  editCompanyUser: EditCompanyUserPayload;
  getClientErrorForTesting: Scalars["Boolean"];
  getServerErrorForTesting: Scalars["Boolean"];
  migrateCompanyToAegis: MigrateCompanyToAegisPayload;
  registerCompanyInfo: RegisterCompanyInfoPayload;
  registerCompanyUser: RegisterCompanyUserPayload;
  registerMemberWithBizsol: RegisterMemberWithBizsolPayload;
  registerMemberWithConnectBoard: RegisterMemberWithConnectBoardPayload;
  registerNewCompany: RegisterNewCompanyPayload;
  registerNewCompanyWithBizsol: RegisterNewCompanyWithBizsolPayload;
  registerNewCompanyWithConnectBoard: RegisterNewCompanyWithConnectBoardPayload;
  registerProvisionalCompanyUser: Scalars["Boolean"];
  registerProvisionalCompanyWithBizsol: Scalars["Boolean"];
  registerProvisionalCompanyWithConnectBoard: Scalars["Boolean"];
  registerVerifiedCompanyWithBizsol: RegisterVerifiedCompanyWithBizsolPayload;
  registerVerifiedCompanyWithConnectBoard: RegisterVerifiedCompanyWithConnectBoardPayload;
  renameCompany: Scalars["Boolean"];
  requestChangeEmailAddress: RequestChangeEmailAddressPayload;
  resignTermsOfService: Scalars["Boolean"];
  retryMigrateCompanyToAegis: RetryMigrateCompanyToAegisPayload;
  sendForgotPasswordMail: Scalars["Boolean"];
  signInWithBizsol?: Maybe<SignInWithBizsolPayload>;
  signInWithConnectBoard?: Maybe<SignInWithConnectBoardPayload>;
  signOut: SignOutPayload;
  switchBizsolID?: Maybe<SwitchBizsolIdPayload>;
  syncPasswordToAegis: SyncPasswordToAegisPayload;
  updatePasswordWithToken: Scalars["Boolean"];
  updateTemporaryPassword: UpdateTemporaryPasswordPayload;
  verifyChangeToAdminToken: VerifyChangeToAdminTokenPayload;
  verifyEmailAddress: VerifyEmailAddressPayload;
  verifyForgotPasswordToken: Scalars["Boolean"];
  verifyProvisionalRegistrationToken: VerifyProvisionalRegistrationTokenPayload;
  verifyProvisionalRegistrationTokenWithBizsol: VerifyProvisionalRegistrationTokenWithBizsolPayload;
  verifyProvisionalRegistrationTokenWithConnectBoard: VerifyProvisionalRegistrationTokenWithConnectBoardPayload;
};

export type MutationApplyForChangeToAdminArgs = {
  input?: InputMaybe<ApplyForChangeToAdminInput>;
};

export type MutationCancelWaitingForConnectToBizsolArgs = {
  input?: InputMaybe<CancelWaitingForConnectToBizsolInput>;
};

export type MutationChangeBizsolStateToWaitingArgs = {
  input?: InputMaybe<ChangeBizsolStateToWaitingInput>;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationChangeToAdminArgs = {
  input?: InputMaybe<ChangeToAdminInput>;
};

export type MutationChangeToMemberArgs = {
  input?: InputMaybe<ChangeToMemberInput>;
};

export type MutationConnectToBizsolArgs = {
  input?: InputMaybe<ConnectToBizsolInput>;
};

export type MutationConnectToConnectBoardArgs = {
  input?: InputMaybe<ConnectToConnectBoardInput>;
};

export type MutationDeleteCompanyUserArgs = {
  input?: InputMaybe<DeleteCompanyUserInput>;
};

export type MutationDisconnectFromBizsolArgs = {
  input?: InputMaybe<DisconnectFromBizsolInput>;
};

export type MutationEditCompanyInfoArgs = {
  input?: InputMaybe<EditCompanyInfoInput>;
};

export type MutationEditCompanyUserArgs = {
  input?: InputMaybe<EditCompanyUserInput>;
};

export type MutationRegisterCompanyInfoArgs = {
  input?: InputMaybe<RegisterCompanyInfoInput>;
};

export type MutationRegisterCompanyUserArgs = {
  input?: InputMaybe<RegisterCompanyUserInput>;
};

export type MutationRegisterMemberWithBizsolArgs = {
  input?: InputMaybe<RegisterMemberWithBizsolInput>;
};

export type MutationRegisterMemberWithConnectBoardArgs = {
  input?: InputMaybe<RegisterMemberWithConnectBoardInput>;
};

export type MutationRegisterNewCompanyArgs = {
  input?: InputMaybe<RegisterNewCompanyInput>;
};

export type MutationRegisterNewCompanyWithBizsolArgs = {
  input?: InputMaybe<RegisterNewCompanyWithBizsolInput>;
};

export type MutationRegisterNewCompanyWithConnectBoardArgs = {
  input?: InputMaybe<RegisterNewCompanyWithConnectBoardInput>;
};

export type MutationRegisterProvisionalCompanyUserArgs = {
  input?: InputMaybe<RegisterProvisionalCompanyUserInput>;
};

export type MutationRegisterProvisionalCompanyWithBizsolArgs = {
  input?: InputMaybe<RegisterProvisionalCompanyWithBizsolInput>;
};

export type MutationRegisterProvisionalCompanyWithConnectBoardArgs = {
  input?: InputMaybe<RegisterProvisionalCompanyWithConnectBoardInput>;
};

export type MutationRegisterVerifiedCompanyWithBizsolArgs = {
  input?: InputMaybe<RegisterVerifiedCompanyWithBizsolInput>;
};

export type MutationRegisterVerifiedCompanyWithConnectBoardArgs = {
  input?: InputMaybe<RegisterVerifiedCompanyWithConnectBoardInput>;
};

export type MutationRenameCompanyArgs = {
  input?: InputMaybe<RenameCompanyInput>;
};

export type MutationRequestChangeEmailAddressArgs = {
  input?: InputMaybe<RequestChangeEmailAddressInput>;
};

export type MutationSendForgotPasswordMailArgs = {
  input?: InputMaybe<SendForgotPasswordMailInput>;
};

export type MutationSignInWithBizsolArgs = {
  input?: InputMaybe<SignInWithBizsolInput>;
};

export type MutationSignInWithConnectBoardArgs = {
  input?: InputMaybe<SignInWithConnectBoardInput>;
};

export type MutationSignOutArgs = {
  input?: InputMaybe<SignOutInput>;
};

export type MutationSwitchBizsolIdArgs = {
  input?: InputMaybe<SwitchBizsolIdInput>;
};

export type MutationSyncPasswordToAegisArgs = {
  input: SyncPasswordToAegisInput;
};

export type MutationUpdatePasswordWithTokenArgs = {
  input?: InputMaybe<UpdatePasswordWithTokenInput>;
};

export type MutationUpdateTemporaryPasswordArgs = {
  input?: InputMaybe<UpdateTemporaryPasswordInput>;
};

export type MutationVerifyChangeToAdminTokenArgs = {
  input?: InputMaybe<VerifyChangeToAdminTokenInput>;
};

export type MutationVerifyEmailAddressArgs = {
  input?: InputMaybe<VerifyEmailAddressInput>;
};

export type MutationVerifyForgotPasswordTokenArgs = {
  input?: InputMaybe<VerifyForgotPasswordTokenInput>;
};

export type MutationVerifyProvisionalRegistrationTokenArgs = {
  input?: InputMaybe<VerifyProvisionalRegistrationTokenInput>;
};

export type MutationVerifyProvisionalRegistrationTokenWithBizsolArgs = {
  input?: InputMaybe<VerifyProvisionalRegistrationTokenWithBizsolInput>;
};

export type MutationVerifyProvisionalRegistrationTokenWithConnectBoardArgs = {
  input?: InputMaybe<VerifyProvisionalRegistrationTokenWithConnectBoardInput>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor: Scalars["String"];
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  startCursor: Scalars["String"];
};

export type Query = {
  __typename?: "Query";
  addresses?: Maybe<Array<Address>>;
  bankBranchOffices?: Maybe<Array<BankBranchOffice>>;
  bizSolUserInfo: BizSolUserInfo;
  company?: Maybe<Company>;
  connectBoardUserInfo: ConnectBoardUserInfo;
  getSession: Session;
  me: User;
  resolveIdp?: Maybe<Scalars["String"]>;
  services: Services;
  servicesForPublic: Services;
  user?: Maybe<User>;
  users: UserConnection;
};

export type QueryAddressesArgs = {
  postalCode: Scalars["String"];
};

export type QueryBizSolUserInfoArgs = {
  code?: InputMaybe<Scalars["RegistrationCode"]>;
};

export type QueryConnectBoardUserInfoArgs = {
  code?: InputMaybe<Scalars["RegistrationCode"]>;
};

export type QueryResolveIdpArgs = {
  clientId?: InputMaybe<Scalars["String"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
  responseType?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  username: Scalars["String"];
};

export type QueryUserArgs = {
  sub: Scalars["ID"];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type RegisterCompanyInfoInput = {
  blockBuildingName?: InputMaybe<Scalars["String"]>;
  branchOfficeId: Scalars["Int"];
  businessContent?: InputMaybe<Scalars["String"]>;
  capital?: InputMaybe<Scalars["Int"]>;
  companyBusinessType: BusinessType;
  companyNameStoreName: Scalars["String"];
  companyNameStoreNameKana?: InputMaybe<Scalars["String"]>;
  corporateNumber?: InputMaybe<Scalars["String"]>;
  foundationDate?: InputMaybe<Scalars["String"]>;
  industriesLarge?: InputMaybe<Scalars["String"]>;
  industriesMiddle?: InputMaybe<Scalars["String"]>;
  insuranceAgencyCode?: InputMaybe<Scalars["String"]>;
  insuranceAgencyName?: InputMaybe<Scalars["String"]>;
  mainUserName: Scalars["String"];
  mainUserPhoneNumber: Scalars["String"];
  municipality?: InputMaybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  postalCode?: InputMaybe<Scalars["String"]>;
  prefectures?: InputMaybe<Scalars["String"]>;
  qualifiedInvoiceIssuerRegistrationNumber?: InputMaybe<Scalars["String"]>;
  representativeName: Scalars["String"];
  settlementMonth?: InputMaybe<Scalars["String"]>;
  staffCount?: InputMaybe<Scalars["String"]>;
};

export type RegisterCompanyInfoPayload = {
  __typename?: "RegisterCompanyInfoPayload";
  result: Scalars["Boolean"];
};

export type RegisterCompanyUserInput = {
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password: Scalars["String"];
  username: Scalars["String"];
};

export type RegisterCompanyUserPayload = {
  __typename?: "RegisterCompanyUserPayload";
  user: User;
};

export type RegisterMemberWithBizsolInput = {
  client_id: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  registrationCode: Scalars["RegistrationCode"];
};

export type RegisterMemberWithBizsolPayload = {
  __typename?: "RegisterMemberWithBizsolPayload";
  token?: Maybe<AuthToken>;
};

export type RegisterMemberWithConnectBoardInput = {
  client_id: Scalars["String"];
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  registrationCode: Scalars["ConnBoardRegistrationCode"];
};

export type RegisterMemberWithConnectBoardPayload = {
  __typename?: "RegisterMemberWithConnectBoardPayload";
  token?: Maybe<AuthToken>;
};

export type RegisterNewCompanyInput = {
  companyName: Scalars["String"];
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password: Scalars["String"];
  token: Scalars["String"];
  username: Scalars["String"];
};

export type RegisterNewCompanyPayload = {
  __typename?: "RegisterNewCompanyPayload";
  result: Scalars["Boolean"];
};

export type RegisterNewCompanyWithBizsolInput = {
  client_id: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  registrationCode: Scalars["RegistrationCode"];
};

export type RegisterNewCompanyWithBizsolPayload = {
  __typename?: "RegisterNewCompanyWithBizsolPayload";
  token?: Maybe<AuthToken>;
};

export type RegisterNewCompanyWithConnectBoardInput = {
  client_id: Scalars["String"];
  companyName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  registrationCode: Scalars["ConnBoardRegistrationCode"];
};

export type RegisterNewCompanyWithConnectBoardPayload = {
  __typename?: "RegisterNewCompanyWithConnectBoardPayload";
  token?: Maybe<AuthToken>;
};

export type RegisterProvisionalCompanyUserInput = {
  app: Scalars["String"];
  email: Scalars["String"];
};

export type RegisterProvisionalCompanyWithBizsolInput = {
  app: Scalars["String"];
  email: Scalars["String"];
  registrationCode: Scalars["RegistrationCode"];
};

export type RegisterProvisionalCompanyWithConnectBoardInput = {
  app: Scalars["String"];
  email: Scalars["String"];
  registrationCode: Scalars["ConnBoardRegistrationCode"];
};

export type RegisterVerifiedCompanyWithBizsolInput = {
  client_id: Scalars["String"];
  email?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  password?: InputMaybe<Scalars["String"]>;
  registrationCode: Scalars["RegistrationCode"];
};

export type RegisterVerifiedCompanyWithBizsolPayload = {
  __typename?: "RegisterVerifiedCompanyWithBizsolPayload";
  token?: Maybe<AuthToken>;
};

export type RegisterVerifiedCompanyWithConnectBoardInput = {
  client_id: Scalars["String"];
  companyName?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  registrationCode: Scalars["ConnBoardRegistrationCode"];
};

export type RegisterVerifiedCompanyWithConnectBoardPayload = {
  __typename?: "RegisterVerifiedCompanyWithConnectBoardPayload";
  token?: Maybe<AuthToken>;
};

export type RegistrationToken = {
  __typename?: "RegistrationToken";
  code: Scalars["RegistrationCode"];
  type: RegistrationTokenType;
};

export enum RegistrationTokenType {
  Company = "company",
  User = "user",
}

export type RenameCompanyInput = {
  name: Scalars["String"];
};

export type RequestChangeEmailAddressInput = {
  email: Scalars["String"];
  sub: Scalars["String"];
};

export type RequestChangeEmailAddressPayload = {
  __typename?: "RequestChangeEmailAddressPayload";
  result: Scalars["Boolean"];
};

export type RetryMigrateCompanyToAegisPayload = {
  __typename?: "RetryMigrateCompanyToAegisPayload";
  failedUsers: Scalars["Int"];
};

export enum Role {
  AdminUser = "ADMIN_USER",
  Invalid = "INVALID",
  MemberUser = "MEMBER_USER",
  PublicUser = "PUBLIC_USER",
}

export type SendForgotPasswordMailInput = {
  app: Scalars["String"];
  email: Scalars["String"];
};

export type Service = {
  __typename?: "Service";
  redirectURL: Scalars["String"];
  using: Scalars["Boolean"];
};

export type Services = {
  __typename?: "Services";
  bfm: Service;
  dxf: Service;
  invoice: Service;
  loan: Service;
};

export type Session = {
  __typename?: "Session";
  authority: Authority;
  email: Scalars["String"];
  emailVerified: Scalars["Boolean"];
  preferredUsername?: Maybe<Scalars["String"]>;
  sub: Scalars["ID"];
  userType: UserType;
  username: Scalars["String"];
  xCompanyID: Scalars["String"];
};

export type SignInWithBizsolInput = {
  client_id: Scalars["String"];
  code: Scalars["String"];
  redirect_uri: Scalars["String"];
};

export type SignInWithBizsolPayload = {
  __typename?: "SignInWithBizsolPayload";
  registrationToken?: Maybe<RegistrationToken>;
  token?: Maybe<AuthToken>;
};

export type SignInWithConnectBoardInput = {
  client_id: Scalars["String"];
  code: Scalars["String"];
  redirect_uri: Scalars["String"];
};

export type SignInWithConnectBoardPayload = {
  __typename?: "SignInWithConnectBoardPayload";
  registrationToken?: Maybe<ConnBoardRegistrationToken>;
  token?: Maybe<AuthToken>;
};

export type SignOutInput = {
  idTokenHint?: InputMaybe<Scalars["String"]>;
  postLogoutRedirectUri?: InputMaybe<Scalars["String"]>;
};

export type SignOutPayload = {
  __typename?: "SignOutPayload";
  logoutURL?: Maybe<Scalars["String"]>;
};

export type SwitchBizsolIdInput = {
  client_id: Scalars["String"];
  sso_bizsol_sub: Scalars["String"];
};

export type SwitchBizsolIdPayload = {
  __typename?: "SwitchBizsolIDPayload";
  token?: Maybe<AuthToken>;
};

export type SyncPasswordToAegisInput = {
  password: Scalars["String"];
};

export type SyncPasswordToAegisPayload = {
  __typename?: "SyncPasswordToAegisPayload";
  success: Scalars["Boolean"];
};

export type UpdatePasswordWithTokenInput = {
  password: Scalars["String"];
  token: Scalars["String"];
};

export type UpdateTemporaryPasswordInput = {
  password: Scalars["String"];
  sub: Scalars["ID"];
};

export type UpdateTemporaryPasswordPayload = {
  __typename?: "UpdateTemporaryPasswordPayload";
  result: Scalars["Boolean"];
};

export type User = {
  __typename?: "User";
  authority: Authority;
  bizsolLoginID?: Maybe<Scalars["String"]>;
  bizsolState?: Maybe<BizsolState>;
  companyName: Scalars["String"];
  connectBoardLoginID?: Maybe<Scalars["String"]>;
  connectBoardState?: Maybe<ConnectBoardState>;
  createdAt?: Maybe<Scalars["Date"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  firstNameKana: Scalars["String"];
  lastName: Scalars["String"];
  lastNameKana: Scalars["String"];
  middleName: Scalars["String"];
  middleNameKana: Scalars["String"];
  migrationStatus?: Maybe<UserMigrationInfo>;
  resignedTermsOfService?: Maybe<Scalars["Boolean"]>;
  sub: Scalars["ID"];
  updatedAt?: Maybe<Scalars["Date"]>;
  userType: UserType;
  username: Scalars["String"];
  waitingForChangeToAdmin: Scalars["Boolean"];
  xCompanyID: Scalars["String"];
};

export type UserConnection = {
  __typename?: "UserConnection";
  pageInfo: PageInfo;
  users?: Maybe<Array<User>>;
};

export type UserMigrationInfo = {
  __typename?: "UserMigrationInfo";
  passwordSync: Scalars["Boolean"];
  syncStatus: UserSyncStatus;
};

export enum UserSyncStatus {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Pending = "PENDING",
  Success = "SUCCESS",
}

export enum UserType {
  Bank = "bank",
  Company = "company",
}

export type VerifyChangeToAdminTokenInput = {
  token: Scalars["String"];
};

export type VerifyChangeToAdminTokenPayload = {
  __typename?: "VerifyChangeToAdminTokenPayload";
  result: Scalars["Boolean"];
};

export type VerifyEmailAddressInput = {
  token: Scalars["String"];
};

export type VerifyEmailAddressPayload = {
  __typename?: "VerifyEmailAddressPayload";
  result: Scalars["Boolean"];
};

export type VerifyForgotPasswordTokenInput = {
  token: Scalars["String"];
};

export type VerifyProvisionalRegistrationTokenInput = {
  token: Scalars["String"];
};

export type VerifyProvisionalRegistrationTokenPayload = {
  __typename?: "VerifyProvisionalRegistrationTokenPayload";
  email: Scalars["String"];
  result: Scalars["Boolean"];
};

export type VerifyProvisionalRegistrationTokenWithBizsolInput = {
  token: Scalars["String"];
};

export type VerifyProvisionalRegistrationTokenWithBizsolPayload = {
  __typename?: "VerifyProvisionalRegistrationTokenWithBizsolPayload";
  email: Scalars["String"];
  registrationCode: Scalars["String"];
  result: Scalars["Boolean"];
};

export type VerifyProvisionalRegistrationTokenWithConnectBoardInput = {
  token: Scalars["String"];
};

export type VerifyProvisionalRegistrationTokenWithConnectBoardPayload = {
  __typename?: "VerifyProvisionalRegistrationTokenWithConnectBoardPayload";
  email: Scalars["String"];
  registrationCode: Scalars["String"];
  result: Scalars["Boolean"];
};

export type AcceptCompanyWithdrawalPayload = {
  __typename?: "acceptCompanyWithdrawalPayload";
  result: Scalars["Boolean"];
};

export type RegisterProvisionalCompanyUserMutationVariables = Exact<{
  input: RegisterProvisionalCompanyUserInput;
}>;

export type RegisterProvisionalCompanyUserMutation = {
  __typename?: "Mutation";
  registerProvisionalCompanyUser: boolean;
};

export type RegisterCompanyUserMutationVariables = Exact<{
  input: RegisterCompanyUserInput;
}>;

export type RegisterCompanyUserMutation = {
  __typename?: "Mutation";
  registerCompanyUser: {
    __typename?: "RegisterCompanyUserPayload";
    user: {
      __typename?: "User";
      sub: string;
      username: string;
      authority: Authority;
      lastName: string;
      lastNameKana: string;
      middleName: string;
      middleNameKana: string;
      firstName: string;
      firstNameKana: string;
    };
  };
};

export type EditCompanyUserMutationVariables = Exact<{
  input?: InputMaybe<EditCompanyUserInput>;
}>;

export type EditCompanyUserMutation = {
  __typename?: "Mutation";
  editCompanyUser: {
    __typename?: "EditCompanyUserPayload";
    user: {
      __typename?: "User";
      sub: string;
      username: string;
      authority: Authority;
      email: string;
      lastName: string;
      lastNameKana: string;
      middleName: string;
      middleNameKana: string;
      firstName: string;
      firstNameKana: string;
    };
  };
};

export type DeleteCompanyUserMutationVariables = Exact<{
  input: DeleteCompanyUserInput;
}>;

export type DeleteCompanyUserMutation = {
  __typename?: "Mutation";
  deleteCompanyUser: {
    __typename?: "DeleteCompanyUserPayload";
    result: boolean;
  };
};

export type SendForgotPasswordMailMutationVariables = Exact<{
  input: SendForgotPasswordMailInput;
}>;

export type SendForgotPasswordMailMutation = {
  __typename?: "Mutation";
  sendForgotPasswordMail: boolean;
};

export type VerifyForgotPasswordTokenMutationVariables = Exact<{
  input: VerifyForgotPasswordTokenInput;
}>;

export type VerifyForgotPasswordTokenMutation = {
  __typename?: "Mutation";
  verifyForgotPasswordToken: boolean;
};

export type UpdatePasswordWithTokenMutationVariables = Exact<{
  token: Scalars["String"];
  password: Scalars["String"];
}>;

export type UpdatePasswordWithTokenMutation = {
  __typename?: "Mutation";
  updatePasswordWithToken: boolean;
};

export type RenameCompanyMutationVariables = Exact<{
  input: RenameCompanyInput;
}>;

export type RenameCompanyMutation = {
  __typename?: "Mutation";
  renameCompany: boolean;
};

export type ResignTermsOfServiceMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResignTermsOfServiceMutation = {
  __typename?: "Mutation";
  resignTermsOfService: boolean;
};

export type VerifyProvisionalRegistrationTokenMutationVariables = Exact<{
  input: VerifyProvisionalRegistrationTokenInput;
}>;

export type VerifyProvisionalRegistrationTokenMutation = {
  __typename?: "Mutation";
  verifyProvisionalRegistrationToken: {
    __typename?: "VerifyProvisionalRegistrationTokenPayload";
    email: string;
    result: boolean;
  };
};

export type RegisterNewCompanyMutationVariables = Exact<{
  input: RegisterNewCompanyInput;
}>;

export type RegisterNewCompanyMutation = {
  __typename?: "Mutation";
  registerNewCompany: {
    __typename?: "RegisterNewCompanyPayload";
    result: boolean;
  };
};

export type AcceptCompanyWithdrawalMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AcceptCompanyWithdrawalMutation = {
  __typename?: "Mutation";
  acceptCompanyWithdrawal: {
    __typename?: "acceptCompanyWithdrawalPayload";
    result: boolean;
  };
};

export type ApplyForChangeToAdminMutationVariables = Exact<{
  input: ApplyForChangeToAdminInput;
}>;

export type ApplyForChangeToAdminMutation = {
  __typename?: "Mutation";
  applyForChangeToAdmin: boolean;
};

export type VerifyChangeToAdminTokenMutationVariables = Exact<{
  input: VerifyChangeToAdminTokenInput;
}>;

export type VerifyChangeToAdminTokenMutation = {
  __typename?: "Mutation";
  verifyChangeToAdminToken: {
    __typename?: "VerifyChangeToAdminTokenPayload";
    result: boolean;
  };
};

export type ChangeToAdminMutationVariables = Exact<{
  input: ChangeToAdminInput;
}>;

export type ChangeToAdminMutation = {
  __typename?: "Mutation";
  changeToAdmin: { __typename?: "ChangeToAdminPayload"; result: boolean };
};

export type ChangeToMemberMutationVariables = Exact<{
  input: ChangeToMemberInput;
}>;

export type ChangeToMemberMutation = {
  __typename?: "Mutation";
  changeToMember: { __typename?: "ChangeToMemberPayload"; result: boolean };
};

export type ChangeBizsolStateToWaitingMutationVariables = Exact<{
  input: ChangeBizsolStateToWaitingInput;
}>;

export type ChangeBizsolStateToWaitingMutation = {
  __typename?: "Mutation";
  changeBizsolStateToWaiting: {
    __typename?: "ChangeBizsolStateToWaitingPayload";
    result: boolean;
  };
};

export type CancelWaitingForConnectToBizsolMutationVariables = Exact<{
  input: CancelWaitingForConnectToBizsolInput;
}>;

export type CancelWaitingForConnectToBizsolMutation = {
  __typename?: "Mutation";
  cancelWaitingForConnectToBizsol?: {
    __typename?: "CancelWaitingForConnectToBizsolPayload";
    result: boolean;
  } | null;
};

export type DisconnectFromBizsolMutationVariables = Exact<{
  input: DisconnectFromBizsolInput;
}>;

export type DisconnectFromBizsolMutation = {
  __typename?: "Mutation";
  disconnectFromBizsol: {
    __typename?: "DisconnectFromBizsolPayload";
    result: boolean;
  };
};

export type RequestChangeEmailAddressMutationVariables = Exact<{
  input: RequestChangeEmailAddressInput;
}>;

export type RequestChangeEmailAddressMutation = {
  __typename?: "Mutation";
  requestChangeEmailAddress: {
    __typename?: "RequestChangeEmailAddressPayload";
    result: boolean;
  };
};

export type VerifyEmailAddressMutationVariables = Exact<{
  input: VerifyEmailAddressInput;
}>;

export type VerifyEmailAddressMutation = {
  __typename?: "Mutation";
  verifyEmailAddress: {
    __typename?: "VerifyEmailAddressPayload";
    result: boolean;
  };
};

export type SignInWithBizsolMutationVariables = Exact<{
  input: SignInWithBizsolInput;
}>;

export type SignInWithBizsolMutation = {
  __typename?: "Mutation";
  signInWithBizsol?: {
    __typename?: "SignInWithBizsolPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
    registrationToken?: {
      __typename?: "RegistrationToken";
      type: RegistrationTokenType;
      code: any;
    } | null;
  } | null;
};

export type ConnectToBizsolMutationVariables = Exact<{
  input: ConnectToBizsolInput;
}>;

export type ConnectToBizsolMutation = {
  __typename?: "Mutation";
  connectToBizsol?: {
    __typename?: "ConnectToBizsolPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  } | null;
};

export type SwitchBizsolIdMutationVariables = Exact<{
  input: SwitchBizsolIdInput;
}>;

export type SwitchBizsolIdMutation = {
  __typename?: "Mutation";
  switchBizsolID?: {
    __typename?: "SwitchBizsolIDPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  } | null;
};

export type RegisterProvisionalCompanyWithBizsolMutationVariables = Exact<{
  input: RegisterProvisionalCompanyWithBizsolInput;
}>;

export type RegisterProvisionalCompanyWithBizsolMutation = {
  __typename?: "Mutation";
  registerProvisionalCompanyWithBizsol: boolean;
};

export type VerifyProvisionalRegistrationTokenWithBizsolMutationVariables =
  Exact<{
    input: VerifyProvisionalRegistrationTokenWithBizsolInput;
  }>;

export type VerifyProvisionalRegistrationTokenWithBizsolMutation = {
  __typename?: "Mutation";
  verifyProvisionalRegistrationTokenWithBizsol: {
    __typename?: "VerifyProvisionalRegistrationTokenWithBizsolPayload";
    email: string;
    result: boolean;
    registrationCode: string;
  };
};

export type RegisterVerifiedCompanyWithBizsolMutationVariables = Exact<{
  input: RegisterVerifiedCompanyWithBizsolInput;
}>;

export type RegisterVerifiedCompanyWithBizsolMutation = {
  __typename?: "Mutation";
  registerVerifiedCompanyWithBizsol: {
    __typename?: "RegisterVerifiedCompanyWithBizsolPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type RegisterNewCompanyWithBizsolMutationVariables = Exact<{
  input: RegisterNewCompanyWithBizsolInput;
}>;

export type RegisterNewCompanyWithBizsolMutation = {
  __typename?: "Mutation";
  registerNewCompanyWithBizsol: {
    __typename?: "RegisterNewCompanyWithBizsolPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type RegisterMemberWithBizsolMutationVariables = Exact<{
  input: RegisterMemberWithBizsolInput;
}>;

export type RegisterMemberWithBizsolMutation = {
  __typename?: "Mutation";
  registerMemberWithBizsol: {
    __typename?: "RegisterMemberWithBizsolPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type RegisterCompanyInfoMutationVariables = Exact<{
  input: RegisterCompanyInfoInput;
}>;

export type RegisterCompanyInfoMutation = {
  __typename?: "Mutation";
  registerCompanyInfo: {
    __typename?: "RegisterCompanyInfoPayload";
    result: boolean;
  };
};

export type EditCompanyInfoMutationVariables = Exact<{
  input: EditCompanyInfoInput;
}>;

export type EditCompanyInfoMutation = {
  __typename?: "Mutation";
  editCompanyInfo: { __typename?: "EditCompanyInfoPayload"; result: boolean };
};

export type SignInWithConnectBoardMutationVariables = Exact<{
  input: SignInWithConnectBoardInput;
}>;

export type SignInWithConnectBoardMutation = {
  __typename?: "Mutation";
  signInWithConnectBoard?: {
    __typename?: "SignInWithConnectBoardPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
    registrationToken?: {
      __typename?: "ConnBoardRegistrationToken";
      type: RegistrationTokenType;
      code: any;
    } | null;
  } | null;
};

export type ConnectToConnectBoardMutationVariables = Exact<{
  input: ConnectToConnectBoardInput;
}>;

export type ConnectToConnectBoardMutation = {
  __typename?: "Mutation";
  connectToConnectBoard?: {
    __typename?: "ConnectToConnectBoardPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  } | null;
};

export type RegisterProvisionalCompanyWithConnectBoardMutationVariables =
  Exact<{
    input: RegisterProvisionalCompanyWithConnectBoardInput;
  }>;

export type RegisterProvisionalCompanyWithConnectBoardMutation = {
  __typename?: "Mutation";
  registerProvisionalCompanyWithConnectBoard: boolean;
};

export type VerifyProvisionalRegistrationTokenWithConnectBoardMutationVariables =
  Exact<{
    input: VerifyProvisionalRegistrationTokenWithConnectBoardInput;
  }>;

export type VerifyProvisionalRegistrationTokenWithConnectBoardMutation = {
  __typename?: "Mutation";
  verifyProvisionalRegistrationTokenWithConnectBoard: {
    __typename?: "VerifyProvisionalRegistrationTokenWithConnectBoardPayload";
    email: string;
    result: boolean;
    registrationCode: string;
  };
};

export type RegisterVerifiedCompanyWithConnectBoardMutationVariables = Exact<{
  input: RegisterVerifiedCompanyWithConnectBoardInput;
}>;

export type RegisterVerifiedCompanyWithConnectBoardMutation = {
  __typename?: "Mutation";
  registerVerifiedCompanyWithConnectBoard: {
    __typename?: "RegisterVerifiedCompanyWithConnectBoardPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type RegisterNewCompanyWithConnectBoardMutationVariables = Exact<{
  input: RegisterNewCompanyWithConnectBoardInput;
}>;

export type RegisterNewCompanyWithConnectBoardMutation = {
  __typename?: "Mutation";
  registerNewCompanyWithConnectBoard: {
    __typename?: "RegisterNewCompanyWithConnectBoardPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type RegisterMemberWithConnectBoardMutationVariables = Exact<{
  input: RegisterMemberWithConnectBoardInput;
}>;

export type RegisterMemberWithConnectBoardMutation = {
  __typename?: "Mutation";
  registerMemberWithConnectBoard: {
    __typename?: "RegisterMemberWithConnectBoardPayload";
    token?: {
      __typename?: "AuthToken";
      access_token: string;
      id_token: any;
      refresh_token: string;
      token_type: string;
    } | null;
  };
};

export type UpdateTemporaryPasswordMutationVariables = Exact<{
  input: UpdateTemporaryPasswordInput;
}>;

export type UpdateTemporaryPasswordMutation = {
  __typename?: "Mutation";
  updateTemporaryPassword: {
    __typename?: "UpdateTemporaryPasswordPayload";
    result: boolean;
  };
};

export type GetServerErrorMutationVariables = Exact<{ [key: string]: never }>;

export type GetServerErrorMutation = {
  __typename?: "Mutation";
  getServerErrorForTesting: boolean;
};

export type GetClientErrorMutationVariables = Exact<{ [key: string]: never }>;

export type GetClientErrorMutation = {
  __typename?: "Mutation";
  getClientErrorForTesting: boolean;
};

export type MigrateCompanyToAegisMutationVariables = Exact<{
  [key: string]: never;
}>;

export type MigrateCompanyToAegisMutation = {
  __typename?: "Mutation";
  migrateCompanyToAegis: {
    __typename?: "MigrateCompanyToAegisPayload";
    totalUsers: number;
  };
};

export type RetryMigrateCompanyToAegisMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RetryMigrateCompanyToAegisMutation = {
  __typename?: "Mutation";
  retryMigrateCompanyToAegis: {
    __typename?: "RetryMigrateCompanyToAegisPayload";
    failedUsers: number;
  };
};

export type SyncPasswordToAegisMutationVariables = Exact<{
  input: SyncPasswordToAegisInput;
}>;

export type SyncPasswordToAegisMutation = {
  __typename?: "Mutation";
  syncPasswordToAegis: {
    __typename?: "SyncPasswordToAegisPayload";
    success: boolean;
  };
};

export type SignOutMutationVariables = Exact<{
  input?: InputMaybe<SignOutInput>;
}>;

export type SignOutMutation = {
  __typename?: "Mutation";
  signOut: { __typename?: "SignOutPayload"; logoutURL?: string | null };
};

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;

export type ChangePasswordMutation = {
  __typename?: "Mutation";
  changePassword: boolean;
};

export type GetUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
}>;

export type GetUsersQuery = {
  __typename?: "Query";
  users: {
    __typename?: "UserConnection";
    users?: Array<{
      __typename?: "User";
      sub: string;
      username: string;
      authority: Authority;
      email: string;
      lastName: string;
      lastNameKana: string;
      middleName: string;
      middleNameKana: string;
      firstName: string;
      firstNameKana: string;
      waitingForChangeToAdmin: boolean;
      bizsolState?: BizsolState | null;
      bizsolLoginID?: string | null;
      connectBoardState?: ConnectBoardState | null;
      connectBoardLoginID?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      migrationStatus?: {
        __typename?: "UserMigrationInfo";
        syncStatus: UserSyncStatus;
        passwordSync: boolean;
      } | null;
    }> | null;
    pageInfo: {
      __typename?: "PageInfo";
      startCursor: string;
      endCursor: string;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type GetUserQueryVariables = Exact<{
  sub: Scalars["ID"];
}>;

export type GetUserQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "User";
    sub: string;
    username: string;
    authority: Authority;
    email: string;
    lastName: string;
    lastNameKana: string;
    middleName: string;
    middleNameKana: string;
    firstName: string;
    firstNameKana: string;
    waitingForChangeToAdmin: boolean;
    bizsolState?: BizsolState | null;
    bizsolLoginID?: string | null;
    connectBoardState?: ConnectBoardState | null;
    connectBoardLoginID?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    migrationStatus?: {
      __typename?: "UserMigrationInfo";
      syncStatus: UserSyncStatus;
      passwordSync: boolean;
    } | null;
  } | null;
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: "Query";
  me: {
    __typename?: "User";
    sub: string;
    username: string;
    authority: Authority;
    email: string;
    lastName: string;
    lastNameKana: string;
    middleName: string;
    middleNameKana: string;
    firstName: string;
    firstNameKana: string;
    companyName: string;
    bizsolState?: BizsolState | null;
    connectBoardState?: ConnectBoardState | null;
    resignedTermsOfService?: boolean | null;
    xCompanyID: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    migrationStatus?: {
      __typename?: "UserMigrationInfo";
      syncStatus: UserSyncStatus;
      passwordSync: boolean;
    } | null;
  };
};

export type GetMyBizsolStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyBizsolStateQuery = {
  __typename?: "Query";
  me: { __typename?: "User"; bizsolState?: BizsolState | null };
};

export type GetMyConnectBoardStateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMyConnectBoardStateQuery = {
  __typename?: "Query";
  me: { __typename?: "User"; connectBoardState?: ConnectBoardState | null };
};

export type ServicesQueryVariables = Exact<{ [key: string]: never }>;

export type ServicesQuery = {
  __typename?: "Query";
  services: {
    __typename?: "Services";
    dxf: { __typename?: "Service"; redirectURL: string; using: boolean };
    invoice: { __typename?: "Service"; redirectURL: string; using: boolean };
    bfm: { __typename?: "Service"; redirectURL: string; using: boolean };
    loan: { __typename?: "Service"; redirectURL: string; using: boolean };
  };
};

export type ServicesForPublicQueryVariables = Exact<{ [key: string]: never }>;

export type ServicesForPublicQuery = {
  __typename?: "Query";
  servicesForPublic: {
    __typename?: "Services";
    dxf: { __typename?: "Service"; redirectURL: string; using: boolean };
    invoice: { __typename?: "Service"; redirectURL: string; using: boolean };
    bfm: { __typename?: "Service"; redirectURL: string; using: boolean };
    loan: { __typename?: "Service"; redirectURL: string; using: boolean };
  };
};

export type GetBizsolEmailQueryVariables = Exact<{
  registrationCode?: InputMaybe<Scalars["RegistrationCode"]>;
}>;

export type GetBizsolEmailQuery = {
  __typename?: "Query";
  bizSolUserInfo: { __typename?: "BizSolUserInfo"; email: string };
};

export type GetBankBranchOfficesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBankBranchOfficesQuery = {
  __typename?: "Query";
  bankBranchOffices?: Array<{
    __typename?: "BankBranchOffice";
    bankId: number;
    branchOfficeId: number;
    branchOfficeCode: string;
    branchOfficeName?: string | null;
    isHeadOfficeOn?: boolean | null;
  }> | null;
};

export type GetCompanyInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyInfoQuery = {
  __typename?: "Query";
  company?: {
    __typename?: "Company";
    companyID: number;
    branchOfficeId: number;
    displayCompanyId: string;
    companyNameStoreName: string;
    companyNameStoreNameKana?: string | null;
    representativeName: string;
    representativeEmailAddress?: string | null;
    phoneNumber: string;
    industriesLarge?: string | null;
    industriesMiddle?: string | null;
    postalCode?: string | null;
    prefectures?: string | null;
    municipality?: string | null;
    blockBuildingName?: string | null;
    settlementMonth?: string | null;
    foundationDate?: string | null;
    capital?: number | null;
    staffCount?: string | null;
    siteUrl?: string | null;
    businessContent?: string | null;
    corporateNumber?: string | null;
    qualifiedInvoiceIssuerRegistrationNumber?: string | null;
    mainUserName?: string | null;
    mainUserPhoneNumber?: string | null;
    insuranceAgencyCode?: string | null;
    insuranceAgencyName?: string | null;
    companyBusinessType?: BusinessType | null;
    representativeBirthDate?: string | null;
    migrationStatus?: CompanyMigrationStatus | null;
  } | null;
};

export type GetAddressQueryVariables = Exact<{
  postalCode: Scalars["String"];
}>;

export type GetAddressQuery = {
  __typename?: "Query";
  addresses?: Array<{
    __typename?: "Address";
    prefectures: string;
    municipality: string;
    blockBuildingName: string;
  }> | null;
};

export type GetSessionQueryVariables = Exact<{ [key: string]: never }>;

export type GetSessionQuery = {
  __typename?: "Query";
  getSession: {
    __typename?: "Session";
    sub: string;
    username: string;
    email: string;
    emailVerified: boolean;
    authority: Authority;
    userType: UserType;
    xCompanyID: string;
    preferredUsername?: string | null;
  };
};

export type ResolveIdpQueryVariables = Exact<{
  username: Scalars["String"];
  clientId?: InputMaybe<Scalars["String"]>;
  redirectUri?: InputMaybe<Scalars["String"]>;
  state?: InputMaybe<Scalars["String"]>;
  responseType?: InputMaybe<Scalars["String"]>;
}>;

export type ResolveIdpQuery = {
  __typename?: "Query";
  resolveIdp?: string | null;
};

export const RegisterProvisionalCompanyUserDocument = gql`
  mutation registerProvisionalCompanyUser(
    $input: RegisterProvisionalCompanyUserInput!
  ) {
    registerProvisionalCompanyUser(input: $input)
  }
`;
export type RegisterProvisionalCompanyUserMutationFn = Apollo.MutationFunction<
  RegisterProvisionalCompanyUserMutation,
  RegisterProvisionalCompanyUserMutationVariables
>;

/**
 * __useRegisterProvisionalCompanyUserMutation__
 *
 * To run a mutation, you first call `useRegisterProvisionalCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProvisionalCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProvisionalCompanyUserMutation, { data, loading, error }] = useRegisterProvisionalCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterProvisionalCompanyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterProvisionalCompanyUserMutation,
    RegisterProvisionalCompanyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterProvisionalCompanyUserMutation,
    RegisterProvisionalCompanyUserMutationVariables
  >(RegisterProvisionalCompanyUserDocument, options);
}
export type RegisterProvisionalCompanyUserMutationHookResult = ReturnType<
  typeof useRegisterProvisionalCompanyUserMutation
>;
export type RegisterProvisionalCompanyUserMutationResult =
  Apollo.MutationResult<RegisterProvisionalCompanyUserMutation>;
export type RegisterProvisionalCompanyUserMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterProvisionalCompanyUserMutation,
    RegisterProvisionalCompanyUserMutationVariables
  >;
export const RegisterCompanyUserDocument = gql`
  mutation registerCompanyUser($input: RegisterCompanyUserInput!) {
    registerCompanyUser(input: $input) {
      user {
        sub
        username
        authority
        lastName
        lastNameKana
        middleName
        middleNameKana
        firstName
        firstNameKana
      }
    }
  }
`;
export type RegisterCompanyUserMutationFn = Apollo.MutationFunction<
  RegisterCompanyUserMutation,
  RegisterCompanyUserMutationVariables
>;

/**
 * __useRegisterCompanyUserMutation__
 *
 * To run a mutation, you first call `useRegisterCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCompanyUserMutation, { data, loading, error }] = useRegisterCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCompanyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterCompanyUserMutation,
    RegisterCompanyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterCompanyUserMutation,
    RegisterCompanyUserMutationVariables
  >(RegisterCompanyUserDocument, options);
}
export type RegisterCompanyUserMutationHookResult = ReturnType<
  typeof useRegisterCompanyUserMutation
>;
export type RegisterCompanyUserMutationResult =
  Apollo.MutationResult<RegisterCompanyUserMutation>;
export type RegisterCompanyUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterCompanyUserMutation,
  RegisterCompanyUserMutationVariables
>;
export const EditCompanyUserDocument = gql`
  mutation editCompanyUser($input: EditCompanyUserInput) {
    editCompanyUser(input: $input) {
      user {
        sub
        username
        authority
        email
        lastName
        lastNameKana
        middleName
        middleNameKana
        firstName
        firstNameKana
      }
    }
  }
`;
export type EditCompanyUserMutationFn = Apollo.MutationFunction<
  EditCompanyUserMutation,
  EditCompanyUserMutationVariables
>;

/**
 * __useEditCompanyUserMutation__
 *
 * To run a mutation, you first call `useEditCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyUserMutation, { data, loading, error }] = useEditCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCompanyUserMutation,
    EditCompanyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCompanyUserMutation,
    EditCompanyUserMutationVariables
  >(EditCompanyUserDocument, options);
}
export type EditCompanyUserMutationHookResult = ReturnType<
  typeof useEditCompanyUserMutation
>;
export type EditCompanyUserMutationResult =
  Apollo.MutationResult<EditCompanyUserMutation>;
export type EditCompanyUserMutationOptions = Apollo.BaseMutationOptions<
  EditCompanyUserMutation,
  EditCompanyUserMutationVariables
>;
export const DeleteCompanyUserDocument = gql`
  mutation deleteCompanyUser($input: DeleteCompanyUserInput!) {
    deleteCompanyUser(input: $input) {
      result
    }
  }
`;
export type DeleteCompanyUserMutationFn = Apollo.MutationFunction<
  DeleteCompanyUserMutation,
  DeleteCompanyUserMutationVariables
>;

/**
 * __useDeleteCompanyUserMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyUserMutation, { data, loading, error }] = useDeleteCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyUserMutation,
    DeleteCompanyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCompanyUserMutation,
    DeleteCompanyUserMutationVariables
  >(DeleteCompanyUserDocument, options);
}
export type DeleteCompanyUserMutationHookResult = ReturnType<
  typeof useDeleteCompanyUserMutation
>;
export type DeleteCompanyUserMutationResult =
  Apollo.MutationResult<DeleteCompanyUserMutation>;
export type DeleteCompanyUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyUserMutation,
  DeleteCompanyUserMutationVariables
>;
export const SendForgotPasswordMailDocument = gql`
  mutation sendForgotPasswordMail($input: SendForgotPasswordMailInput!) {
    sendForgotPasswordMail(input: $input)
  }
`;
export type SendForgotPasswordMailMutationFn = Apollo.MutationFunction<
  SendForgotPasswordMailMutation,
  SendForgotPasswordMailMutationVariables
>;

/**
 * __useSendForgotPasswordMailMutation__
 *
 * To run a mutation, you first call `useSendForgotPasswordMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForgotPasswordMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForgotPasswordMailMutation, { data, loading, error }] = useSendForgotPasswordMailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendForgotPasswordMailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendForgotPasswordMailMutation,
    SendForgotPasswordMailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendForgotPasswordMailMutation,
    SendForgotPasswordMailMutationVariables
  >(SendForgotPasswordMailDocument, options);
}
export type SendForgotPasswordMailMutationHookResult = ReturnType<
  typeof useSendForgotPasswordMailMutation
>;
export type SendForgotPasswordMailMutationResult =
  Apollo.MutationResult<SendForgotPasswordMailMutation>;
export type SendForgotPasswordMailMutationOptions = Apollo.BaseMutationOptions<
  SendForgotPasswordMailMutation,
  SendForgotPasswordMailMutationVariables
>;
export const VerifyForgotPasswordTokenDocument = gql`
  mutation verifyForgotPasswordToken($input: VerifyForgotPasswordTokenInput!) {
    verifyForgotPasswordToken(input: $input)
  }
`;
export type VerifyForgotPasswordTokenMutationFn = Apollo.MutationFunction<
  VerifyForgotPasswordTokenMutation,
  VerifyForgotPasswordTokenMutationVariables
>;

/**
 * __useVerifyForgotPasswordTokenMutation__
 *
 * To run a mutation, you first call `useVerifyForgotPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyForgotPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyForgotPasswordTokenMutation, { data, loading, error }] = useVerifyForgotPasswordTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyForgotPasswordTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyForgotPasswordTokenMutation,
    VerifyForgotPasswordTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyForgotPasswordTokenMutation,
    VerifyForgotPasswordTokenMutationVariables
  >(VerifyForgotPasswordTokenDocument, options);
}
export type VerifyForgotPasswordTokenMutationHookResult = ReturnType<
  typeof useVerifyForgotPasswordTokenMutation
>;
export type VerifyForgotPasswordTokenMutationResult =
  Apollo.MutationResult<VerifyForgotPasswordTokenMutation>;
export type VerifyForgotPasswordTokenMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyForgotPasswordTokenMutation,
    VerifyForgotPasswordTokenMutationVariables
  >;
export const UpdatePasswordWithTokenDocument = gql`
  mutation updatePasswordWithToken($token: String!, $password: String!) {
    updatePasswordWithToken(input: { token: $token, password: $password })
  }
`;
export type UpdatePasswordWithTokenMutationFn = Apollo.MutationFunction<
  UpdatePasswordWithTokenMutation,
  UpdatePasswordWithTokenMutationVariables
>;

/**
 * __useUpdatePasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordWithTokenMutation, { data, loading, error }] = useUpdatePasswordWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdatePasswordWithTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePasswordWithTokenMutation,
    UpdatePasswordWithTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePasswordWithTokenMutation,
    UpdatePasswordWithTokenMutationVariables
  >(UpdatePasswordWithTokenDocument, options);
}
export type UpdatePasswordWithTokenMutationHookResult = ReturnType<
  typeof useUpdatePasswordWithTokenMutation
>;
export type UpdatePasswordWithTokenMutationResult =
  Apollo.MutationResult<UpdatePasswordWithTokenMutation>;
export type UpdatePasswordWithTokenMutationOptions = Apollo.BaseMutationOptions<
  UpdatePasswordWithTokenMutation,
  UpdatePasswordWithTokenMutationVariables
>;
export const RenameCompanyDocument = gql`
  mutation renameCompany($input: RenameCompanyInput!) {
    renameCompany(input: $input)
  }
`;
export type RenameCompanyMutationFn = Apollo.MutationFunction<
  RenameCompanyMutation,
  RenameCompanyMutationVariables
>;

/**
 * __useRenameCompanyMutation__
 *
 * To run a mutation, you first call `useRenameCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCompanyMutation, { data, loading, error }] = useRenameCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameCompanyMutation,
    RenameCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenameCompanyMutation,
    RenameCompanyMutationVariables
  >(RenameCompanyDocument, options);
}
export type RenameCompanyMutationHookResult = ReturnType<
  typeof useRenameCompanyMutation
>;
export type RenameCompanyMutationResult =
  Apollo.MutationResult<RenameCompanyMutation>;
export type RenameCompanyMutationOptions = Apollo.BaseMutationOptions<
  RenameCompanyMutation,
  RenameCompanyMutationVariables
>;
export const ResignTermsOfServiceDocument = gql`
  mutation resignTermsOfService {
    resignTermsOfService
  }
`;
export type ResignTermsOfServiceMutationFn = Apollo.MutationFunction<
  ResignTermsOfServiceMutation,
  ResignTermsOfServiceMutationVariables
>;

/**
 * __useResignTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useResignTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResignTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resignTermsOfServiceMutation, { data, loading, error }] = useResignTermsOfServiceMutation({
 *   variables: {
 *   },
 * });
 */
export function useResignTermsOfServiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResignTermsOfServiceMutation,
    ResignTermsOfServiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResignTermsOfServiceMutation,
    ResignTermsOfServiceMutationVariables
  >(ResignTermsOfServiceDocument, options);
}
export type ResignTermsOfServiceMutationHookResult = ReturnType<
  typeof useResignTermsOfServiceMutation
>;
export type ResignTermsOfServiceMutationResult =
  Apollo.MutationResult<ResignTermsOfServiceMutation>;
export type ResignTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<
  ResignTermsOfServiceMutation,
  ResignTermsOfServiceMutationVariables
>;
export const VerifyProvisionalRegistrationTokenDocument = gql`
  mutation verifyProvisionalRegistrationToken(
    $input: VerifyProvisionalRegistrationTokenInput!
  ) {
    verifyProvisionalRegistrationToken(input: $input) {
      email
      result
    }
  }
`;
export type VerifyProvisionalRegistrationTokenMutationFn =
  Apollo.MutationFunction<
    VerifyProvisionalRegistrationTokenMutation,
    VerifyProvisionalRegistrationTokenMutationVariables
  >;

/**
 * __useVerifyProvisionalRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useVerifyProvisionalRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyProvisionalRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyProvisionalRegistrationTokenMutation, { data, loading, error }] = useVerifyProvisionalRegistrationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyProvisionalRegistrationTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyProvisionalRegistrationTokenMutation,
    VerifyProvisionalRegistrationTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyProvisionalRegistrationTokenMutation,
    VerifyProvisionalRegistrationTokenMutationVariables
  >(VerifyProvisionalRegistrationTokenDocument, options);
}
export type VerifyProvisionalRegistrationTokenMutationHookResult = ReturnType<
  typeof useVerifyProvisionalRegistrationTokenMutation
>;
export type VerifyProvisionalRegistrationTokenMutationResult =
  Apollo.MutationResult<VerifyProvisionalRegistrationTokenMutation>;
export type VerifyProvisionalRegistrationTokenMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyProvisionalRegistrationTokenMutation,
    VerifyProvisionalRegistrationTokenMutationVariables
  >;
export const RegisterNewCompanyDocument = gql`
  mutation registerNewCompany($input: RegisterNewCompanyInput!) {
    registerNewCompany(input: $input) {
      result
    }
  }
`;
export type RegisterNewCompanyMutationFn = Apollo.MutationFunction<
  RegisterNewCompanyMutation,
  RegisterNewCompanyMutationVariables
>;

/**
 * __useRegisterNewCompanyMutation__
 *
 * To run a mutation, you first call `useRegisterNewCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewCompanyMutation, { data, loading, error }] = useRegisterNewCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterNewCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterNewCompanyMutation,
    RegisterNewCompanyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterNewCompanyMutation,
    RegisterNewCompanyMutationVariables
  >(RegisterNewCompanyDocument, options);
}
export type RegisterNewCompanyMutationHookResult = ReturnType<
  typeof useRegisterNewCompanyMutation
>;
export type RegisterNewCompanyMutationResult =
  Apollo.MutationResult<RegisterNewCompanyMutation>;
export type RegisterNewCompanyMutationOptions = Apollo.BaseMutationOptions<
  RegisterNewCompanyMutation,
  RegisterNewCompanyMutationVariables
>;
export const AcceptCompanyWithdrawalDocument = gql`
  mutation acceptCompanyWithdrawal {
    acceptCompanyWithdrawal {
      result
    }
  }
`;
export type AcceptCompanyWithdrawalMutationFn = Apollo.MutationFunction<
  AcceptCompanyWithdrawalMutation,
  AcceptCompanyWithdrawalMutationVariables
>;

/**
 * __useAcceptCompanyWithdrawalMutation__
 *
 * To run a mutation, you first call `useAcceptCompanyWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompanyWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCompanyWithdrawalMutation, { data, loading, error }] = useAcceptCompanyWithdrawalMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptCompanyWithdrawalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptCompanyWithdrawalMutation,
    AcceptCompanyWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptCompanyWithdrawalMutation,
    AcceptCompanyWithdrawalMutationVariables
  >(AcceptCompanyWithdrawalDocument, options);
}
export type AcceptCompanyWithdrawalMutationHookResult = ReturnType<
  typeof useAcceptCompanyWithdrawalMutation
>;
export type AcceptCompanyWithdrawalMutationResult =
  Apollo.MutationResult<AcceptCompanyWithdrawalMutation>;
export type AcceptCompanyWithdrawalMutationOptions = Apollo.BaseMutationOptions<
  AcceptCompanyWithdrawalMutation,
  AcceptCompanyWithdrawalMutationVariables
>;
export const ApplyForChangeToAdminDocument = gql`
  mutation applyForChangeToAdmin($input: ApplyForChangeToAdminInput!) {
    applyForChangeToAdmin(input: $input)
  }
`;
export type ApplyForChangeToAdminMutationFn = Apollo.MutationFunction<
  ApplyForChangeToAdminMutation,
  ApplyForChangeToAdminMutationVariables
>;

/**
 * __useApplyForChangeToAdminMutation__
 *
 * To run a mutation, you first call `useApplyForChangeToAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyForChangeToAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyForChangeToAdminMutation, { data, loading, error }] = useApplyForChangeToAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyForChangeToAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyForChangeToAdminMutation,
    ApplyForChangeToAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplyForChangeToAdminMutation,
    ApplyForChangeToAdminMutationVariables
  >(ApplyForChangeToAdminDocument, options);
}
export type ApplyForChangeToAdminMutationHookResult = ReturnType<
  typeof useApplyForChangeToAdminMutation
>;
export type ApplyForChangeToAdminMutationResult =
  Apollo.MutationResult<ApplyForChangeToAdminMutation>;
export type ApplyForChangeToAdminMutationOptions = Apollo.BaseMutationOptions<
  ApplyForChangeToAdminMutation,
  ApplyForChangeToAdminMutationVariables
>;
export const VerifyChangeToAdminTokenDocument = gql`
  mutation verifyChangeToAdminToken($input: VerifyChangeToAdminTokenInput!) {
    verifyChangeToAdminToken(input: $input) {
      result
    }
  }
`;
export type VerifyChangeToAdminTokenMutationFn = Apollo.MutationFunction<
  VerifyChangeToAdminTokenMutation,
  VerifyChangeToAdminTokenMutationVariables
>;

/**
 * __useVerifyChangeToAdminTokenMutation__
 *
 * To run a mutation, you first call `useVerifyChangeToAdminTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyChangeToAdminTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyChangeToAdminTokenMutation, { data, loading, error }] = useVerifyChangeToAdminTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyChangeToAdminTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyChangeToAdminTokenMutation,
    VerifyChangeToAdminTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyChangeToAdminTokenMutation,
    VerifyChangeToAdminTokenMutationVariables
  >(VerifyChangeToAdminTokenDocument, options);
}
export type VerifyChangeToAdminTokenMutationHookResult = ReturnType<
  typeof useVerifyChangeToAdminTokenMutation
>;
export type VerifyChangeToAdminTokenMutationResult =
  Apollo.MutationResult<VerifyChangeToAdminTokenMutation>;
export type VerifyChangeToAdminTokenMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyChangeToAdminTokenMutation,
    VerifyChangeToAdminTokenMutationVariables
  >;
export const ChangeToAdminDocument = gql`
  mutation changeToAdmin($input: ChangeToAdminInput!) {
    changeToAdmin(input: $input) {
      result
    }
  }
`;
export type ChangeToAdminMutationFn = Apollo.MutationFunction<
  ChangeToAdminMutation,
  ChangeToAdminMutationVariables
>;

/**
 * __useChangeToAdminMutation__
 *
 * To run a mutation, you first call `useChangeToAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeToAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeToAdminMutation, { data, loading, error }] = useChangeToAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeToAdminMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeToAdminMutation,
    ChangeToAdminMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeToAdminMutation,
    ChangeToAdminMutationVariables
  >(ChangeToAdminDocument, options);
}
export type ChangeToAdminMutationHookResult = ReturnType<
  typeof useChangeToAdminMutation
>;
export type ChangeToAdminMutationResult =
  Apollo.MutationResult<ChangeToAdminMutation>;
export type ChangeToAdminMutationOptions = Apollo.BaseMutationOptions<
  ChangeToAdminMutation,
  ChangeToAdminMutationVariables
>;
export const ChangeToMemberDocument = gql`
  mutation changeToMember($input: ChangeToMemberInput!) {
    changeToMember(input: $input) {
      result
    }
  }
`;
export type ChangeToMemberMutationFn = Apollo.MutationFunction<
  ChangeToMemberMutation,
  ChangeToMemberMutationVariables
>;

/**
 * __useChangeToMemberMutation__
 *
 * To run a mutation, you first call `useChangeToMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeToMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeToMemberMutation, { data, loading, error }] = useChangeToMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeToMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeToMemberMutation,
    ChangeToMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeToMemberMutation,
    ChangeToMemberMutationVariables
  >(ChangeToMemberDocument, options);
}
export type ChangeToMemberMutationHookResult = ReturnType<
  typeof useChangeToMemberMutation
>;
export type ChangeToMemberMutationResult =
  Apollo.MutationResult<ChangeToMemberMutation>;
export type ChangeToMemberMutationOptions = Apollo.BaseMutationOptions<
  ChangeToMemberMutation,
  ChangeToMemberMutationVariables
>;
export const ChangeBizsolStateToWaitingDocument = gql`
  mutation changeBizsolStateToWaiting(
    $input: ChangeBizsolStateToWaitingInput!
  ) {
    changeBizsolStateToWaiting(input: $input) {
      result
    }
  }
`;
export type ChangeBizsolStateToWaitingMutationFn = Apollo.MutationFunction<
  ChangeBizsolStateToWaitingMutation,
  ChangeBizsolStateToWaitingMutationVariables
>;

/**
 * __useChangeBizsolStateToWaitingMutation__
 *
 * To run a mutation, you first call `useChangeBizsolStateToWaitingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBizsolStateToWaitingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBizsolStateToWaitingMutation, { data, loading, error }] = useChangeBizsolStateToWaitingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeBizsolStateToWaitingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeBizsolStateToWaitingMutation,
    ChangeBizsolStateToWaitingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeBizsolStateToWaitingMutation,
    ChangeBizsolStateToWaitingMutationVariables
  >(ChangeBizsolStateToWaitingDocument, options);
}
export type ChangeBizsolStateToWaitingMutationHookResult = ReturnType<
  typeof useChangeBizsolStateToWaitingMutation
>;
export type ChangeBizsolStateToWaitingMutationResult =
  Apollo.MutationResult<ChangeBizsolStateToWaitingMutation>;
export type ChangeBizsolStateToWaitingMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeBizsolStateToWaitingMutation,
    ChangeBizsolStateToWaitingMutationVariables
  >;
export const CancelWaitingForConnectToBizsolDocument = gql`
  mutation cancelWaitingForConnectToBizsol(
    $input: CancelWaitingForConnectToBizsolInput!
  ) {
    cancelWaitingForConnectToBizsol(input: $input) {
      result
    }
  }
`;
export type CancelWaitingForConnectToBizsolMutationFn = Apollo.MutationFunction<
  CancelWaitingForConnectToBizsolMutation,
  CancelWaitingForConnectToBizsolMutationVariables
>;

/**
 * __useCancelWaitingForConnectToBizsolMutation__
 *
 * To run a mutation, you first call `useCancelWaitingForConnectToBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWaitingForConnectToBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWaitingForConnectToBizsolMutation, { data, loading, error }] = useCancelWaitingForConnectToBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWaitingForConnectToBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelWaitingForConnectToBizsolMutation,
    CancelWaitingForConnectToBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelWaitingForConnectToBizsolMutation,
    CancelWaitingForConnectToBizsolMutationVariables
  >(CancelWaitingForConnectToBizsolDocument, options);
}
export type CancelWaitingForConnectToBizsolMutationHookResult = ReturnType<
  typeof useCancelWaitingForConnectToBizsolMutation
>;
export type CancelWaitingForConnectToBizsolMutationResult =
  Apollo.MutationResult<CancelWaitingForConnectToBizsolMutation>;
export type CancelWaitingForConnectToBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    CancelWaitingForConnectToBizsolMutation,
    CancelWaitingForConnectToBizsolMutationVariables
  >;
export const DisconnectFromBizsolDocument = gql`
  mutation disconnectFromBizsol($input: DisconnectFromBizsolInput!) {
    disconnectFromBizsol(input: $input) {
      result
    }
  }
`;
export type DisconnectFromBizsolMutationFn = Apollo.MutationFunction<
  DisconnectFromBizsolMutation,
  DisconnectFromBizsolMutationVariables
>;

/**
 * __useDisconnectFromBizsolMutation__
 *
 * To run a mutation, you first call `useDisconnectFromBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectFromBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectFromBizsolMutation, { data, loading, error }] = useDisconnectFromBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectFromBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectFromBizsolMutation,
    DisconnectFromBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisconnectFromBizsolMutation,
    DisconnectFromBizsolMutationVariables
  >(DisconnectFromBizsolDocument, options);
}
export type DisconnectFromBizsolMutationHookResult = ReturnType<
  typeof useDisconnectFromBizsolMutation
>;
export type DisconnectFromBizsolMutationResult =
  Apollo.MutationResult<DisconnectFromBizsolMutation>;
export type DisconnectFromBizsolMutationOptions = Apollo.BaseMutationOptions<
  DisconnectFromBizsolMutation,
  DisconnectFromBizsolMutationVariables
>;
export const RequestChangeEmailAddressDocument = gql`
  mutation requestChangeEmailAddress($input: RequestChangeEmailAddressInput!) {
    requestChangeEmailAddress(input: $input) {
      result
    }
  }
`;
export type RequestChangeEmailAddressMutationFn = Apollo.MutationFunction<
  RequestChangeEmailAddressMutation,
  RequestChangeEmailAddressMutationVariables
>;

/**
 * __useRequestChangeEmailAddressMutation__
 *
 * To run a mutation, you first call `useRequestChangeEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangeEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangeEmailAddressMutation, { data, loading, error }] = useRequestChangeEmailAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestChangeEmailAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestChangeEmailAddressMutation,
    RequestChangeEmailAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestChangeEmailAddressMutation,
    RequestChangeEmailAddressMutationVariables
  >(RequestChangeEmailAddressDocument, options);
}
export type RequestChangeEmailAddressMutationHookResult = ReturnType<
  typeof useRequestChangeEmailAddressMutation
>;
export type RequestChangeEmailAddressMutationResult =
  Apollo.MutationResult<RequestChangeEmailAddressMutation>;
export type RequestChangeEmailAddressMutationOptions =
  Apollo.BaseMutationOptions<
    RequestChangeEmailAddressMutation,
    RequestChangeEmailAddressMutationVariables
  >;
export const VerifyEmailAddressDocument = gql`
  mutation verifyEmailAddress($input: VerifyEmailAddressInput!) {
    verifyEmailAddress(input: $input) {
      result
    }
  }
`;
export type VerifyEmailAddressMutationFn = Apollo.MutationFunction<
  VerifyEmailAddressMutation,
  VerifyEmailAddressMutationVariables
>;

/**
 * __useVerifyEmailAddressMutation__
 *
 * To run a mutation, you first call `useVerifyEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailAddressMutation, { data, loading, error }] = useVerifyEmailAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailAddressMutation,
    VerifyEmailAddressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyEmailAddressMutation,
    VerifyEmailAddressMutationVariables
  >(VerifyEmailAddressDocument, options);
}
export type VerifyEmailAddressMutationHookResult = ReturnType<
  typeof useVerifyEmailAddressMutation
>;
export type VerifyEmailAddressMutationResult =
  Apollo.MutationResult<VerifyEmailAddressMutation>;
export type VerifyEmailAddressMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailAddressMutation,
  VerifyEmailAddressMutationVariables
>;
export const SignInWithBizsolDocument = gql`
  mutation signInWithBizsol($input: SignInWithBizsolInput!) {
    signInWithBizsol(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
      registrationToken {
        type
        code
      }
    }
  }
`;
export type SignInWithBizsolMutationFn = Apollo.MutationFunction<
  SignInWithBizsolMutation,
  SignInWithBizsolMutationVariables
>;

/**
 * __useSignInWithBizsolMutation__
 *
 * To run a mutation, you first call `useSignInWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithBizsolMutation, { data, loading, error }] = useSignInWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignInWithBizsolMutation,
    SignInWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignInWithBizsolMutation,
    SignInWithBizsolMutationVariables
  >(SignInWithBizsolDocument, options);
}
export type SignInWithBizsolMutationHookResult = ReturnType<
  typeof useSignInWithBizsolMutation
>;
export type SignInWithBizsolMutationResult =
  Apollo.MutationResult<SignInWithBizsolMutation>;
export type SignInWithBizsolMutationOptions = Apollo.BaseMutationOptions<
  SignInWithBizsolMutation,
  SignInWithBizsolMutationVariables
>;
export const ConnectToBizsolDocument = gql`
  mutation connectToBizsol($input: ConnectToBizsolInput!) {
    connectToBizsol(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type ConnectToBizsolMutationFn = Apollo.MutationFunction<
  ConnectToBizsolMutation,
  ConnectToBizsolMutationVariables
>;

/**
 * __useConnectToBizsolMutation__
 *
 * To run a mutation, you first call `useConnectToBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectToBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectToBizsolMutation, { data, loading, error }] = useConnectToBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectToBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConnectToBizsolMutation,
    ConnectToBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConnectToBizsolMutation,
    ConnectToBizsolMutationVariables
  >(ConnectToBizsolDocument, options);
}
export type ConnectToBizsolMutationHookResult = ReturnType<
  typeof useConnectToBizsolMutation
>;
export type ConnectToBizsolMutationResult =
  Apollo.MutationResult<ConnectToBizsolMutation>;
export type ConnectToBizsolMutationOptions = Apollo.BaseMutationOptions<
  ConnectToBizsolMutation,
  ConnectToBizsolMutationVariables
>;
export const SwitchBizsolIdDocument = gql`
  mutation switchBizsolID($input: SwitchBizsolIDInput!) {
    switchBizsolID(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type SwitchBizsolIdMutationFn = Apollo.MutationFunction<
  SwitchBizsolIdMutation,
  SwitchBizsolIdMutationVariables
>;

/**
 * __useSwitchBizsolIdMutation__
 *
 * To run a mutation, you first call `useSwitchBizsolIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchBizsolIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchBizsolIdMutation, { data, loading, error }] = useSwitchBizsolIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchBizsolIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchBizsolIdMutation,
    SwitchBizsolIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SwitchBizsolIdMutation,
    SwitchBizsolIdMutationVariables
  >(SwitchBizsolIdDocument, options);
}
export type SwitchBizsolIdMutationHookResult = ReturnType<
  typeof useSwitchBizsolIdMutation
>;
export type SwitchBizsolIdMutationResult =
  Apollo.MutationResult<SwitchBizsolIdMutation>;
export type SwitchBizsolIdMutationOptions = Apollo.BaseMutationOptions<
  SwitchBizsolIdMutation,
  SwitchBizsolIdMutationVariables
>;
export const RegisterProvisionalCompanyWithBizsolDocument = gql`
  mutation registerProvisionalCompanyWithBizsol(
    $input: RegisterProvisionalCompanyWithBizsolInput!
  ) {
    registerProvisionalCompanyWithBizsol(input: $input)
  }
`;
export type RegisterProvisionalCompanyWithBizsolMutationFn =
  Apollo.MutationFunction<
    RegisterProvisionalCompanyWithBizsolMutation,
    RegisterProvisionalCompanyWithBizsolMutationVariables
  >;

/**
 * __useRegisterProvisionalCompanyWithBizsolMutation__
 *
 * To run a mutation, you first call `useRegisterProvisionalCompanyWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProvisionalCompanyWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProvisionalCompanyWithBizsolMutation, { data, loading, error }] = useRegisterProvisionalCompanyWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterProvisionalCompanyWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterProvisionalCompanyWithBizsolMutation,
    RegisterProvisionalCompanyWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterProvisionalCompanyWithBizsolMutation,
    RegisterProvisionalCompanyWithBizsolMutationVariables
  >(RegisterProvisionalCompanyWithBizsolDocument, options);
}
export type RegisterProvisionalCompanyWithBizsolMutationHookResult = ReturnType<
  typeof useRegisterProvisionalCompanyWithBizsolMutation
>;
export type RegisterProvisionalCompanyWithBizsolMutationResult =
  Apollo.MutationResult<RegisterProvisionalCompanyWithBizsolMutation>;
export type RegisterProvisionalCompanyWithBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterProvisionalCompanyWithBizsolMutation,
    RegisterProvisionalCompanyWithBizsolMutationVariables
  >;
export const VerifyProvisionalRegistrationTokenWithBizsolDocument = gql`
  mutation verifyProvisionalRegistrationTokenWithBizsol(
    $input: VerifyProvisionalRegistrationTokenWithBizsolInput!
  ) {
    verifyProvisionalRegistrationTokenWithBizsol(input: $input) {
      email
      result
      registrationCode
    }
  }
`;
export type VerifyProvisionalRegistrationTokenWithBizsolMutationFn =
  Apollo.MutationFunction<
    VerifyProvisionalRegistrationTokenWithBizsolMutation,
    VerifyProvisionalRegistrationTokenWithBizsolMutationVariables
  >;

/**
 * __useVerifyProvisionalRegistrationTokenWithBizsolMutation__
 *
 * To run a mutation, you first call `useVerifyProvisionalRegistrationTokenWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyProvisionalRegistrationTokenWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyProvisionalRegistrationTokenWithBizsolMutation, { data, loading, error }] = useVerifyProvisionalRegistrationTokenWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyProvisionalRegistrationTokenWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyProvisionalRegistrationTokenWithBizsolMutation,
    VerifyProvisionalRegistrationTokenWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyProvisionalRegistrationTokenWithBizsolMutation,
    VerifyProvisionalRegistrationTokenWithBizsolMutationVariables
  >(VerifyProvisionalRegistrationTokenWithBizsolDocument, options);
}
export type VerifyProvisionalRegistrationTokenWithBizsolMutationHookResult =
  ReturnType<typeof useVerifyProvisionalRegistrationTokenWithBizsolMutation>;
export type VerifyProvisionalRegistrationTokenWithBizsolMutationResult =
  Apollo.MutationResult<VerifyProvisionalRegistrationTokenWithBizsolMutation>;
export type VerifyProvisionalRegistrationTokenWithBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyProvisionalRegistrationTokenWithBizsolMutation,
    VerifyProvisionalRegistrationTokenWithBizsolMutationVariables
  >;
export const RegisterVerifiedCompanyWithBizsolDocument = gql`
  mutation registerVerifiedCompanyWithBizsol(
    $input: RegisterVerifiedCompanyWithBizsolInput!
  ) {
    registerVerifiedCompanyWithBizsol(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterVerifiedCompanyWithBizsolMutationFn =
  Apollo.MutationFunction<
    RegisterVerifiedCompanyWithBizsolMutation,
    RegisterVerifiedCompanyWithBizsolMutationVariables
  >;

/**
 * __useRegisterVerifiedCompanyWithBizsolMutation__
 *
 * To run a mutation, you first call `useRegisterVerifiedCompanyWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterVerifiedCompanyWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerVerifiedCompanyWithBizsolMutation, { data, loading, error }] = useRegisterVerifiedCompanyWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterVerifiedCompanyWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterVerifiedCompanyWithBizsolMutation,
    RegisterVerifiedCompanyWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterVerifiedCompanyWithBizsolMutation,
    RegisterVerifiedCompanyWithBizsolMutationVariables
  >(RegisterVerifiedCompanyWithBizsolDocument, options);
}
export type RegisterVerifiedCompanyWithBizsolMutationHookResult = ReturnType<
  typeof useRegisterVerifiedCompanyWithBizsolMutation
>;
export type RegisterVerifiedCompanyWithBizsolMutationResult =
  Apollo.MutationResult<RegisterVerifiedCompanyWithBizsolMutation>;
export type RegisterVerifiedCompanyWithBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterVerifiedCompanyWithBizsolMutation,
    RegisterVerifiedCompanyWithBizsolMutationVariables
  >;
export const RegisterNewCompanyWithBizsolDocument = gql`
  mutation registerNewCompanyWithBizsol(
    $input: RegisterNewCompanyWithBizsolInput!
  ) {
    registerNewCompanyWithBizsol(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterNewCompanyWithBizsolMutationFn = Apollo.MutationFunction<
  RegisterNewCompanyWithBizsolMutation,
  RegisterNewCompanyWithBizsolMutationVariables
>;

/**
 * __useRegisterNewCompanyWithBizsolMutation__
 *
 * To run a mutation, you first call `useRegisterNewCompanyWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewCompanyWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewCompanyWithBizsolMutation, { data, loading, error }] = useRegisterNewCompanyWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterNewCompanyWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterNewCompanyWithBizsolMutation,
    RegisterNewCompanyWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterNewCompanyWithBizsolMutation,
    RegisterNewCompanyWithBizsolMutationVariables
  >(RegisterNewCompanyWithBizsolDocument, options);
}
export type RegisterNewCompanyWithBizsolMutationHookResult = ReturnType<
  typeof useRegisterNewCompanyWithBizsolMutation
>;
export type RegisterNewCompanyWithBizsolMutationResult =
  Apollo.MutationResult<RegisterNewCompanyWithBizsolMutation>;
export type RegisterNewCompanyWithBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterNewCompanyWithBizsolMutation,
    RegisterNewCompanyWithBizsolMutationVariables
  >;
export const RegisterMemberWithBizsolDocument = gql`
  mutation registerMemberWithBizsol($input: RegisterMemberWithBizsolInput!) {
    registerMemberWithBizsol(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterMemberWithBizsolMutationFn = Apollo.MutationFunction<
  RegisterMemberWithBizsolMutation,
  RegisterMemberWithBizsolMutationVariables
>;

/**
 * __useRegisterMemberWithBizsolMutation__
 *
 * To run a mutation, you first call `useRegisterMemberWithBizsolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMemberWithBizsolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMemberWithBizsolMutation, { data, loading, error }] = useRegisterMemberWithBizsolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMemberWithBizsolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterMemberWithBizsolMutation,
    RegisterMemberWithBizsolMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterMemberWithBizsolMutation,
    RegisterMemberWithBizsolMutationVariables
  >(RegisterMemberWithBizsolDocument, options);
}
export type RegisterMemberWithBizsolMutationHookResult = ReturnType<
  typeof useRegisterMemberWithBizsolMutation
>;
export type RegisterMemberWithBizsolMutationResult =
  Apollo.MutationResult<RegisterMemberWithBizsolMutation>;
export type RegisterMemberWithBizsolMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterMemberWithBizsolMutation,
    RegisterMemberWithBizsolMutationVariables
  >;
export const RegisterCompanyInfoDocument = gql`
  mutation registerCompanyInfo($input: RegisterCompanyInfoInput!) {
    registerCompanyInfo(input: $input) {
      result
    }
  }
`;
export type RegisterCompanyInfoMutationFn = Apollo.MutationFunction<
  RegisterCompanyInfoMutation,
  RegisterCompanyInfoMutationVariables
>;

/**
 * __useRegisterCompanyInfoMutation__
 *
 * To run a mutation, you first call `useRegisterCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCompanyInfoMutation, { data, loading, error }] = useRegisterCompanyInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCompanyInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterCompanyInfoMutation,
    RegisterCompanyInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterCompanyInfoMutation,
    RegisterCompanyInfoMutationVariables
  >(RegisterCompanyInfoDocument, options);
}
export type RegisterCompanyInfoMutationHookResult = ReturnType<
  typeof useRegisterCompanyInfoMutation
>;
export type RegisterCompanyInfoMutationResult =
  Apollo.MutationResult<RegisterCompanyInfoMutation>;
export type RegisterCompanyInfoMutationOptions = Apollo.BaseMutationOptions<
  RegisterCompanyInfoMutation,
  RegisterCompanyInfoMutationVariables
>;
export const EditCompanyInfoDocument = gql`
  mutation editCompanyInfo($input: EditCompanyInfoInput!) {
    editCompanyInfo(input: $input) {
      result
    }
  }
`;
export type EditCompanyInfoMutationFn = Apollo.MutationFunction<
  EditCompanyInfoMutation,
  EditCompanyInfoMutationVariables
>;

/**
 * __useEditCompanyInfoMutation__
 *
 * To run a mutation, you first call `useEditCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyInfoMutation, { data, loading, error }] = useEditCompanyInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCompanyInfoMutation,
    EditCompanyInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCompanyInfoMutation,
    EditCompanyInfoMutationVariables
  >(EditCompanyInfoDocument, options);
}
export type EditCompanyInfoMutationHookResult = ReturnType<
  typeof useEditCompanyInfoMutation
>;
export type EditCompanyInfoMutationResult =
  Apollo.MutationResult<EditCompanyInfoMutation>;
export type EditCompanyInfoMutationOptions = Apollo.BaseMutationOptions<
  EditCompanyInfoMutation,
  EditCompanyInfoMutationVariables
>;
export const SignInWithConnectBoardDocument = gql`
  mutation signInWithConnectBoard($input: SignInWithConnectBoardInput!) {
    signInWithConnectBoard(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
      registrationToken {
        type
        code
      }
    }
  }
`;
export type SignInWithConnectBoardMutationFn = Apollo.MutationFunction<
  SignInWithConnectBoardMutation,
  SignInWithConnectBoardMutationVariables
>;

/**
 * __useSignInWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useSignInWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithConnectBoardMutation, { data, loading, error }] = useSignInWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignInWithConnectBoardMutation,
    SignInWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignInWithConnectBoardMutation,
    SignInWithConnectBoardMutationVariables
  >(SignInWithConnectBoardDocument, options);
}
export type SignInWithConnectBoardMutationHookResult = ReturnType<
  typeof useSignInWithConnectBoardMutation
>;
export type SignInWithConnectBoardMutationResult =
  Apollo.MutationResult<SignInWithConnectBoardMutation>;
export type SignInWithConnectBoardMutationOptions = Apollo.BaseMutationOptions<
  SignInWithConnectBoardMutation,
  SignInWithConnectBoardMutationVariables
>;
export const ConnectToConnectBoardDocument = gql`
  mutation connectToConnectBoard($input: ConnectToConnectBoardInput!) {
    connectToConnectBoard(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type ConnectToConnectBoardMutationFn = Apollo.MutationFunction<
  ConnectToConnectBoardMutation,
  ConnectToConnectBoardMutationVariables
>;

/**
 * __useConnectToConnectBoardMutation__
 *
 * To run a mutation, you first call `useConnectToConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectToConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectToConnectBoardMutation, { data, loading, error }] = useConnectToConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectToConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConnectToConnectBoardMutation,
    ConnectToConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConnectToConnectBoardMutation,
    ConnectToConnectBoardMutationVariables
  >(ConnectToConnectBoardDocument, options);
}
export type ConnectToConnectBoardMutationHookResult = ReturnType<
  typeof useConnectToConnectBoardMutation
>;
export type ConnectToConnectBoardMutationResult =
  Apollo.MutationResult<ConnectToConnectBoardMutation>;
export type ConnectToConnectBoardMutationOptions = Apollo.BaseMutationOptions<
  ConnectToConnectBoardMutation,
  ConnectToConnectBoardMutationVariables
>;
export const RegisterProvisionalCompanyWithConnectBoardDocument = gql`
  mutation registerProvisionalCompanyWithConnectBoard(
    $input: RegisterProvisionalCompanyWithConnectBoardInput!
  ) {
    registerProvisionalCompanyWithConnectBoard(input: $input)
  }
`;
export type RegisterProvisionalCompanyWithConnectBoardMutationFn =
  Apollo.MutationFunction<
    RegisterProvisionalCompanyWithConnectBoardMutation,
    RegisterProvisionalCompanyWithConnectBoardMutationVariables
  >;

/**
 * __useRegisterProvisionalCompanyWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useRegisterProvisionalCompanyWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterProvisionalCompanyWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerProvisionalCompanyWithConnectBoardMutation, { data, loading, error }] = useRegisterProvisionalCompanyWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterProvisionalCompanyWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterProvisionalCompanyWithConnectBoardMutation,
    RegisterProvisionalCompanyWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterProvisionalCompanyWithConnectBoardMutation,
    RegisterProvisionalCompanyWithConnectBoardMutationVariables
  >(RegisterProvisionalCompanyWithConnectBoardDocument, options);
}
export type RegisterProvisionalCompanyWithConnectBoardMutationHookResult =
  ReturnType<typeof useRegisterProvisionalCompanyWithConnectBoardMutation>;
export type RegisterProvisionalCompanyWithConnectBoardMutationResult =
  Apollo.MutationResult<RegisterProvisionalCompanyWithConnectBoardMutation>;
export type RegisterProvisionalCompanyWithConnectBoardMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterProvisionalCompanyWithConnectBoardMutation,
    RegisterProvisionalCompanyWithConnectBoardMutationVariables
  >;
export const VerifyProvisionalRegistrationTokenWithConnectBoardDocument = gql`
  mutation verifyProvisionalRegistrationTokenWithConnectBoard(
    $input: VerifyProvisionalRegistrationTokenWithConnectBoardInput!
  ) {
    verifyProvisionalRegistrationTokenWithConnectBoard(input: $input) {
      email
      result
      registrationCode
    }
  }
`;
export type VerifyProvisionalRegistrationTokenWithConnectBoardMutationFn =
  Apollo.MutationFunction<
    VerifyProvisionalRegistrationTokenWithConnectBoardMutation,
    VerifyProvisionalRegistrationTokenWithConnectBoardMutationVariables
  >;

/**
 * __useVerifyProvisionalRegistrationTokenWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useVerifyProvisionalRegistrationTokenWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyProvisionalRegistrationTokenWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyProvisionalRegistrationTokenWithConnectBoardMutation, { data, loading, error }] = useVerifyProvisionalRegistrationTokenWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyProvisionalRegistrationTokenWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyProvisionalRegistrationTokenWithConnectBoardMutation,
    VerifyProvisionalRegistrationTokenWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyProvisionalRegistrationTokenWithConnectBoardMutation,
    VerifyProvisionalRegistrationTokenWithConnectBoardMutationVariables
  >(VerifyProvisionalRegistrationTokenWithConnectBoardDocument, options);
}
export type VerifyProvisionalRegistrationTokenWithConnectBoardMutationHookResult =
  ReturnType<
    typeof useVerifyProvisionalRegistrationTokenWithConnectBoardMutation
  >;
export type VerifyProvisionalRegistrationTokenWithConnectBoardMutationResult =
  Apollo.MutationResult<VerifyProvisionalRegistrationTokenWithConnectBoardMutation>;
export type VerifyProvisionalRegistrationTokenWithConnectBoardMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyProvisionalRegistrationTokenWithConnectBoardMutation,
    VerifyProvisionalRegistrationTokenWithConnectBoardMutationVariables
  >;
export const RegisterVerifiedCompanyWithConnectBoardDocument = gql`
  mutation registerVerifiedCompanyWithConnectBoard(
    $input: RegisterVerifiedCompanyWithConnectBoardInput!
  ) {
    registerVerifiedCompanyWithConnectBoard(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterVerifiedCompanyWithConnectBoardMutationFn =
  Apollo.MutationFunction<
    RegisterVerifiedCompanyWithConnectBoardMutation,
    RegisterVerifiedCompanyWithConnectBoardMutationVariables
  >;

/**
 * __useRegisterVerifiedCompanyWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useRegisterVerifiedCompanyWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterVerifiedCompanyWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerVerifiedCompanyWithConnectBoardMutation, { data, loading, error }] = useRegisterVerifiedCompanyWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterVerifiedCompanyWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterVerifiedCompanyWithConnectBoardMutation,
    RegisterVerifiedCompanyWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterVerifiedCompanyWithConnectBoardMutation,
    RegisterVerifiedCompanyWithConnectBoardMutationVariables
  >(RegisterVerifiedCompanyWithConnectBoardDocument, options);
}
export type RegisterVerifiedCompanyWithConnectBoardMutationHookResult =
  ReturnType<typeof useRegisterVerifiedCompanyWithConnectBoardMutation>;
export type RegisterVerifiedCompanyWithConnectBoardMutationResult =
  Apollo.MutationResult<RegisterVerifiedCompanyWithConnectBoardMutation>;
export type RegisterVerifiedCompanyWithConnectBoardMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterVerifiedCompanyWithConnectBoardMutation,
    RegisterVerifiedCompanyWithConnectBoardMutationVariables
  >;
export const RegisterNewCompanyWithConnectBoardDocument = gql`
  mutation registerNewCompanyWithConnectBoard(
    $input: RegisterNewCompanyWithConnectBoardInput!
  ) {
    registerNewCompanyWithConnectBoard(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterNewCompanyWithConnectBoardMutationFn =
  Apollo.MutationFunction<
    RegisterNewCompanyWithConnectBoardMutation,
    RegisterNewCompanyWithConnectBoardMutationVariables
  >;

/**
 * __useRegisterNewCompanyWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useRegisterNewCompanyWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterNewCompanyWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerNewCompanyWithConnectBoardMutation, { data, loading, error }] = useRegisterNewCompanyWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterNewCompanyWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterNewCompanyWithConnectBoardMutation,
    RegisterNewCompanyWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterNewCompanyWithConnectBoardMutation,
    RegisterNewCompanyWithConnectBoardMutationVariables
  >(RegisterNewCompanyWithConnectBoardDocument, options);
}
export type RegisterNewCompanyWithConnectBoardMutationHookResult = ReturnType<
  typeof useRegisterNewCompanyWithConnectBoardMutation
>;
export type RegisterNewCompanyWithConnectBoardMutationResult =
  Apollo.MutationResult<RegisterNewCompanyWithConnectBoardMutation>;
export type RegisterNewCompanyWithConnectBoardMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterNewCompanyWithConnectBoardMutation,
    RegisterNewCompanyWithConnectBoardMutationVariables
  >;
export const RegisterMemberWithConnectBoardDocument = gql`
  mutation registerMemberWithConnectBoard(
    $input: RegisterMemberWithConnectBoardInput!
  ) {
    registerMemberWithConnectBoard(input: $input) {
      token {
        access_token
        id_token
        refresh_token
        token_type
      }
    }
  }
`;
export type RegisterMemberWithConnectBoardMutationFn = Apollo.MutationFunction<
  RegisterMemberWithConnectBoardMutation,
  RegisterMemberWithConnectBoardMutationVariables
>;

/**
 * __useRegisterMemberWithConnectBoardMutation__
 *
 * To run a mutation, you first call `useRegisterMemberWithConnectBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMemberWithConnectBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMemberWithConnectBoardMutation, { data, loading, error }] = useRegisterMemberWithConnectBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMemberWithConnectBoardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterMemberWithConnectBoardMutation,
    RegisterMemberWithConnectBoardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterMemberWithConnectBoardMutation,
    RegisterMemberWithConnectBoardMutationVariables
  >(RegisterMemberWithConnectBoardDocument, options);
}
export type RegisterMemberWithConnectBoardMutationHookResult = ReturnType<
  typeof useRegisterMemberWithConnectBoardMutation
>;
export type RegisterMemberWithConnectBoardMutationResult =
  Apollo.MutationResult<RegisterMemberWithConnectBoardMutation>;
export type RegisterMemberWithConnectBoardMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterMemberWithConnectBoardMutation,
    RegisterMemberWithConnectBoardMutationVariables
  >;
export const UpdateTemporaryPasswordDocument = gql`
  mutation updateTemporaryPassword($input: UpdateTemporaryPasswordInput!) {
    updateTemporaryPassword(input: $input) {
      result
    }
  }
`;
export type UpdateTemporaryPasswordMutationFn = Apollo.MutationFunction<
  UpdateTemporaryPasswordMutation,
  UpdateTemporaryPasswordMutationVariables
>;

/**
 * __useUpdateTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemporaryPasswordMutation, { data, loading, error }] = useUpdateTemporaryPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemporaryPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTemporaryPasswordMutation,
    UpdateTemporaryPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTemporaryPasswordMutation,
    UpdateTemporaryPasswordMutationVariables
  >(UpdateTemporaryPasswordDocument, options);
}
export type UpdateTemporaryPasswordMutationHookResult = ReturnType<
  typeof useUpdateTemporaryPasswordMutation
>;
export type UpdateTemporaryPasswordMutationResult =
  Apollo.MutationResult<UpdateTemporaryPasswordMutation>;
export type UpdateTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdateTemporaryPasswordMutation,
  UpdateTemporaryPasswordMutationVariables
>;
export const GetServerErrorDocument = gql`
  mutation getServerError {
    getServerErrorForTesting
  }
`;
export type GetServerErrorMutationFn = Apollo.MutationFunction<
  GetServerErrorMutation,
  GetServerErrorMutationVariables
>;

/**
 * __useGetServerErrorMutation__
 *
 * To run a mutation, you first call `useGetServerErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetServerErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getServerErrorMutation, { data, loading, error }] = useGetServerErrorMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetServerErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetServerErrorMutation,
    GetServerErrorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetServerErrorMutation,
    GetServerErrorMutationVariables
  >(GetServerErrorDocument, options);
}
export type GetServerErrorMutationHookResult = ReturnType<
  typeof useGetServerErrorMutation
>;
export type GetServerErrorMutationResult =
  Apollo.MutationResult<GetServerErrorMutation>;
export type GetServerErrorMutationOptions = Apollo.BaseMutationOptions<
  GetServerErrorMutation,
  GetServerErrorMutationVariables
>;
export const GetClientErrorDocument = gql`
  mutation getClientError {
    getClientErrorForTesting
  }
`;
export type GetClientErrorMutationFn = Apollo.MutationFunction<
  GetClientErrorMutation,
  GetClientErrorMutationVariables
>;

/**
 * __useGetClientErrorMutation__
 *
 * To run a mutation, you first call `useGetClientErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetClientErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getClientErrorMutation, { data, loading, error }] = useGetClientErrorMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetClientErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetClientErrorMutation,
    GetClientErrorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetClientErrorMutation,
    GetClientErrorMutationVariables
  >(GetClientErrorDocument, options);
}
export type GetClientErrorMutationHookResult = ReturnType<
  typeof useGetClientErrorMutation
>;
export type GetClientErrorMutationResult =
  Apollo.MutationResult<GetClientErrorMutation>;
export type GetClientErrorMutationOptions = Apollo.BaseMutationOptions<
  GetClientErrorMutation,
  GetClientErrorMutationVariables
>;
export const MigrateCompanyToAegisDocument = gql`
  mutation migrateCompanyToAegis {
    migrateCompanyToAegis {
      totalUsers
    }
  }
`;
export type MigrateCompanyToAegisMutationFn = Apollo.MutationFunction<
  MigrateCompanyToAegisMutation,
  MigrateCompanyToAegisMutationVariables
>;

/**
 * __useMigrateCompanyToAegisMutation__
 *
 * To run a mutation, you first call `useMigrateCompanyToAegisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateCompanyToAegisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateCompanyToAegisMutation, { data, loading, error }] = useMigrateCompanyToAegisMutation({
 *   variables: {
 *   },
 * });
 */
export function useMigrateCompanyToAegisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MigrateCompanyToAegisMutation,
    MigrateCompanyToAegisMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MigrateCompanyToAegisMutation,
    MigrateCompanyToAegisMutationVariables
  >(MigrateCompanyToAegisDocument, options);
}
export type MigrateCompanyToAegisMutationHookResult = ReturnType<
  typeof useMigrateCompanyToAegisMutation
>;
export type MigrateCompanyToAegisMutationResult =
  Apollo.MutationResult<MigrateCompanyToAegisMutation>;
export type MigrateCompanyToAegisMutationOptions = Apollo.BaseMutationOptions<
  MigrateCompanyToAegisMutation,
  MigrateCompanyToAegisMutationVariables
>;
export const RetryMigrateCompanyToAegisDocument = gql`
  mutation retryMigrateCompanyToAegis {
    retryMigrateCompanyToAegis {
      failedUsers
    }
  }
`;
export type RetryMigrateCompanyToAegisMutationFn = Apollo.MutationFunction<
  RetryMigrateCompanyToAegisMutation,
  RetryMigrateCompanyToAegisMutationVariables
>;

/**
 * __useRetryMigrateCompanyToAegisMutation__
 *
 * To run a mutation, you first call `useRetryMigrateCompanyToAegisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryMigrateCompanyToAegisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryMigrateCompanyToAegisMutation, { data, loading, error }] = useRetryMigrateCompanyToAegisMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetryMigrateCompanyToAegisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryMigrateCompanyToAegisMutation,
    RetryMigrateCompanyToAegisMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryMigrateCompanyToAegisMutation,
    RetryMigrateCompanyToAegisMutationVariables
  >(RetryMigrateCompanyToAegisDocument, options);
}
export type RetryMigrateCompanyToAegisMutationHookResult = ReturnType<
  typeof useRetryMigrateCompanyToAegisMutation
>;
export type RetryMigrateCompanyToAegisMutationResult =
  Apollo.MutationResult<RetryMigrateCompanyToAegisMutation>;
export type RetryMigrateCompanyToAegisMutationOptions =
  Apollo.BaseMutationOptions<
    RetryMigrateCompanyToAegisMutation,
    RetryMigrateCompanyToAegisMutationVariables
  >;
export const SyncPasswordToAegisDocument = gql`
  mutation syncPasswordToAegis($input: SyncPasswordToAegisInput!) {
    syncPasswordToAegis(input: $input) {
      success
    }
  }
`;
export type SyncPasswordToAegisMutationFn = Apollo.MutationFunction<
  SyncPasswordToAegisMutation,
  SyncPasswordToAegisMutationVariables
>;

/**
 * __useSyncPasswordToAegisMutation__
 *
 * To run a mutation, you first call `useSyncPasswordToAegisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPasswordToAegisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPasswordToAegisMutation, { data, loading, error }] = useSyncPasswordToAegisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPasswordToAegisMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncPasswordToAegisMutation,
    SyncPasswordToAegisMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncPasswordToAegisMutation,
    SyncPasswordToAegisMutationVariables
  >(SyncPasswordToAegisDocument, options);
}
export type SyncPasswordToAegisMutationHookResult = ReturnType<
  typeof useSyncPasswordToAegisMutation
>;
export type SyncPasswordToAegisMutationResult =
  Apollo.MutationResult<SyncPasswordToAegisMutation>;
export type SyncPasswordToAegisMutationOptions = Apollo.BaseMutationOptions<
  SyncPasswordToAegisMutation,
  SyncPasswordToAegisMutationVariables
>;
export const SignOutDocument = gql`
  mutation signOut($input: SignOutInput) {
    signOut(input: $input) {
      logoutURL
    }
  }
`;
export type SignOutMutationFn = Apollo.MutationFunction<
  SignOutMutation,
  SignOutMutationVariables
>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignOutMutation,
    SignOutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(
    SignOutDocument,
    options
  );
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
  SignOutMutation,
  SignOutMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation changePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>;
export type ChangePasswordMutationResult =
  Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const GetUsersDocument = gql`
  query getUsers($first: Int, $after: String) {
    users(first: $first, after: $after) {
      users {
        sub
        username
        authority
        email
        lastName
        lastNameKana
        middleName
        middleNameKana
        firstName
        firstNameKana
        waitingForChangeToAdmin
        bizsolState
        bizsolLoginID
        connectBoardState
        connectBoardLoginID
        migrationStatus {
          syncStatus
          passwordSync
        }
        createdAt
        updatedAt
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetUserDocument = gql`
  query getUser($sub: ID!) {
    user(sub: $sub) {
      sub
      username
      authority
      email
      lastName
      lastNameKana
      middleName
      middleNameKana
      firstName
      firstNameKana
      waitingForChangeToAdmin
      bizsolState
      bizsolLoginID
      connectBoardState
      connectBoardLoginID
      migrationStatus {
        syncStatus
        passwordSync
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      sub: // value for 'sub'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const MeDocument = gql`
  query me {
    me {
      sub
      username
      authority
      email
      lastName
      lastNameKana
      middleName
      middleNameKana
      firstName
      firstNameKana
      companyName
      bizsolState
      connectBoardState
      resignedTermsOfService
      migrationStatus {
        syncStatus
        passwordSync
      }
      xCompanyID
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetMyBizsolStateDocument = gql`
  query getMyBizsolState {
    me {
      bizsolState
    }
  }
`;

/**
 * __useGetMyBizsolStateQuery__
 *
 * To run a query within a React component, call `useGetMyBizsolStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBizsolStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBizsolStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBizsolStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyBizsolStateQuery,
    GetMyBizsolStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyBizsolStateQuery, GetMyBizsolStateQueryVariables>(
    GetMyBizsolStateDocument,
    options
  );
}
export function useGetMyBizsolStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyBizsolStateQuery,
    GetMyBizsolStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyBizsolStateQuery,
    GetMyBizsolStateQueryVariables
  >(GetMyBizsolStateDocument, options);
}
export type GetMyBizsolStateQueryHookResult = ReturnType<
  typeof useGetMyBizsolStateQuery
>;
export type GetMyBizsolStateLazyQueryHookResult = ReturnType<
  typeof useGetMyBizsolStateLazyQuery
>;
export type GetMyBizsolStateQueryResult = Apollo.QueryResult<
  GetMyBizsolStateQuery,
  GetMyBizsolStateQueryVariables
>;
export const GetMyConnectBoardStateDocument = gql`
  query getMyConnectBoardState {
    me {
      connectBoardState
    }
  }
`;

/**
 * __useGetMyConnectBoardStateQuery__
 *
 * To run a query within a React component, call `useGetMyConnectBoardStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyConnectBoardStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyConnectBoardStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyConnectBoardStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyConnectBoardStateQuery,
    GetMyConnectBoardStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMyConnectBoardStateQuery,
    GetMyConnectBoardStateQueryVariables
  >(GetMyConnectBoardStateDocument, options);
}
export function useGetMyConnectBoardStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyConnectBoardStateQuery,
    GetMyConnectBoardStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMyConnectBoardStateQuery,
    GetMyConnectBoardStateQueryVariables
  >(GetMyConnectBoardStateDocument, options);
}
export type GetMyConnectBoardStateQueryHookResult = ReturnType<
  typeof useGetMyConnectBoardStateQuery
>;
export type GetMyConnectBoardStateLazyQueryHookResult = ReturnType<
  typeof useGetMyConnectBoardStateLazyQuery
>;
export type GetMyConnectBoardStateQueryResult = Apollo.QueryResult<
  GetMyConnectBoardStateQuery,
  GetMyConnectBoardStateQueryVariables
>;
export const ServicesDocument = gql`
  query services {
    services {
      dxf {
        redirectURL
        using
      }
      invoice {
        redirectURL
        using
      }
      bfm {
        redirectURL
        using
      }
      loan {
        redirectURL
        using
      }
    }
  }
`;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesQuery(
  baseOptions?: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(
    ServicesDocument,
    options
  );
}
export function useServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServicesQuery,
    ServicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(
    ServicesDocument,
    options
  );
}
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<
  typeof useServicesLazyQuery
>;
export type ServicesQueryResult = Apollo.QueryResult<
  ServicesQuery,
  ServicesQueryVariables
>;
export const ServicesForPublicDocument = gql`
  query servicesForPublic {
    servicesForPublic {
      dxf {
        redirectURL
        using
      }
      invoice {
        redirectURL
        using
      }
      bfm {
        redirectURL
        using
      }
      loan {
        redirectURL
        using
      }
    }
  }
`;

/**
 * __useServicesForPublicQuery__
 *
 * To run a query within a React component, call `useServicesForPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesForPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesForPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesForPublicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ServicesForPublicQuery,
    ServicesForPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServicesForPublicQuery,
    ServicesForPublicQueryVariables
  >(ServicesForPublicDocument, options);
}
export function useServicesForPublicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServicesForPublicQuery,
    ServicesForPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServicesForPublicQuery,
    ServicesForPublicQueryVariables
  >(ServicesForPublicDocument, options);
}
export type ServicesForPublicQueryHookResult = ReturnType<
  typeof useServicesForPublicQuery
>;
export type ServicesForPublicLazyQueryHookResult = ReturnType<
  typeof useServicesForPublicLazyQuery
>;
export type ServicesForPublicQueryResult = Apollo.QueryResult<
  ServicesForPublicQuery,
  ServicesForPublicQueryVariables
>;
export const GetBizsolEmailDocument = gql`
  query getBizsolEmail($registrationCode: RegistrationCode) {
    bizSolUserInfo(code: $registrationCode) {
      email
    }
  }
`;

/**
 * __useGetBizsolEmailQuery__
 *
 * To run a query within a React component, call `useGetBizsolEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBizsolEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBizsolEmailQuery({
 *   variables: {
 *      registrationCode: // value for 'registrationCode'
 *   },
 * });
 */
export function useGetBizsolEmailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBizsolEmailQuery,
    GetBizsolEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBizsolEmailQuery, GetBizsolEmailQueryVariables>(
    GetBizsolEmailDocument,
    options
  );
}
export function useGetBizsolEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBizsolEmailQuery,
    GetBizsolEmailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBizsolEmailQuery, GetBizsolEmailQueryVariables>(
    GetBizsolEmailDocument,
    options
  );
}
export type GetBizsolEmailQueryHookResult = ReturnType<
  typeof useGetBizsolEmailQuery
>;
export type GetBizsolEmailLazyQueryHookResult = ReturnType<
  typeof useGetBizsolEmailLazyQuery
>;
export type GetBizsolEmailQueryResult = Apollo.QueryResult<
  GetBizsolEmailQuery,
  GetBizsolEmailQueryVariables
>;
export const GetBankBranchOfficesDocument = gql`
  query getBankBranchOffices {
    bankBranchOffices {
      bankId
      branchOfficeId
      branchOfficeCode
      branchOfficeName
      isHeadOfficeOn
    }
  }
`;

/**
 * __useGetBankBranchOfficesQuery__
 *
 * To run a query within a React component, call `useGetBankBranchOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankBranchOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankBranchOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankBranchOfficesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBankBranchOfficesQuery,
    GetBankBranchOfficesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBankBranchOfficesQuery,
    GetBankBranchOfficesQueryVariables
  >(GetBankBranchOfficesDocument, options);
}
export function useGetBankBranchOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBankBranchOfficesQuery,
    GetBankBranchOfficesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBankBranchOfficesQuery,
    GetBankBranchOfficesQueryVariables
  >(GetBankBranchOfficesDocument, options);
}
export type GetBankBranchOfficesQueryHookResult = ReturnType<
  typeof useGetBankBranchOfficesQuery
>;
export type GetBankBranchOfficesLazyQueryHookResult = ReturnType<
  typeof useGetBankBranchOfficesLazyQuery
>;
export type GetBankBranchOfficesQueryResult = Apollo.QueryResult<
  GetBankBranchOfficesQuery,
  GetBankBranchOfficesQueryVariables
>;
export const GetCompanyInfoDocument = gql`
  query getCompanyInfo {
    company {
      companyID
      branchOfficeId
      displayCompanyId
      companyNameStoreName
      companyNameStoreNameKana
      representativeName
      representativeEmailAddress
      phoneNumber
      industriesLarge
      industriesMiddle
      postalCode
      prefectures
      municipality
      blockBuildingName
      settlementMonth
      foundationDate
      capital
      staffCount
      siteUrl
      businessContent
      corporateNumber
      qualifiedInvoiceIssuerRegistrationNumber
      mainUserName
      mainUserPhoneNumber
      insuranceAgencyCode
      insuranceAgencyName
      companyBusinessType
      representativeBirthDate
      migrationStatus
    }
  }
`;

/**
 * __useGetCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyInfoQuery,
    GetCompanyInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(
    GetCompanyInfoDocument,
    options
  );
}
export function useGetCompanyInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyInfoQuery,
    GetCompanyInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompanyInfoQuery, GetCompanyInfoQueryVariables>(
    GetCompanyInfoDocument,
    options
  );
}
export type GetCompanyInfoQueryHookResult = ReturnType<
  typeof useGetCompanyInfoQuery
>;
export type GetCompanyInfoLazyQueryHookResult = ReturnType<
  typeof useGetCompanyInfoLazyQuery
>;
export type GetCompanyInfoQueryResult = Apollo.QueryResult<
  GetCompanyInfoQuery,
  GetCompanyInfoQueryVariables
>;
export const GetAddressDocument = gql`
  query getAddress($postalCode: String!) {
    addresses(postalCode: $postalCode) {
      prefectures
      municipality
      blockBuildingName
    }
  }
`;

/**
 * __useGetAddressQuery__
 *
 * To run a query within a React component, call `useGetAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressQuery({
 *   variables: {
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useGetAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAddressQuery,
    GetAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAddressQuery, GetAddressQueryVariables>(
    GetAddressDocument,
    options
  );
}
export function useGetAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAddressQuery,
    GetAddressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAddressQuery, GetAddressQueryVariables>(
    GetAddressDocument,
    options
  );
}
export type GetAddressQueryHookResult = ReturnType<typeof useGetAddressQuery>;
export type GetAddressLazyQueryHookResult = ReturnType<
  typeof useGetAddressLazyQuery
>;
export type GetAddressQueryResult = Apollo.QueryResult<
  GetAddressQuery,
  GetAddressQueryVariables
>;
export const GetSessionDocument = gql`
  query getSession {
    getSession {
      sub
      username
      email
      emailVerified
      authority
      userType
      xCompanyID
      preferredUsername
    }
  }
`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSessionQuery,
    GetSessionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export function useGetSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSessionQuery,
    GetSessionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<
  typeof useGetSessionLazyQuery
>;
export type GetSessionQueryResult = Apollo.QueryResult<
  GetSessionQuery,
  GetSessionQueryVariables
>;
export const ResolveIdpDocument = gql`
  query resolveIdp(
    $username: String!
    $clientId: String
    $redirectUri: String
    $state: String
    $responseType: String
  ) {
    resolveIdp(
      username: $username
      clientId: $clientId
      redirectUri: $redirectUri
      state: $state
      responseType: $responseType
    )
  }
`;

/**
 * __useResolveIdpQuery__
 *
 * To run a query within a React component, call `useResolveIdpQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveIdpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveIdpQuery({
 *   variables: {
 *      username: // value for 'username'
 *      clientId: // value for 'clientId'
 *      redirectUri: // value for 'redirectUri'
 *      state: // value for 'state'
 *      responseType: // value for 'responseType'
 *   },
 * });
 */
export function useResolveIdpQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResolveIdpQuery,
    ResolveIdpQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ResolveIdpQuery, ResolveIdpQueryVariables>(
    ResolveIdpDocument,
    options
  );
}
export function useResolveIdpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResolveIdpQuery,
    ResolveIdpQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ResolveIdpQuery, ResolveIdpQueryVariables>(
    ResolveIdpDocument,
    options
  );
}
export type ResolveIdpQueryHookResult = ReturnType<typeof useResolveIdpQuery>;
export type ResolveIdpLazyQueryHookResult = ReturnType<
  typeof useResolveIdpLazyQuery
>;
export type ResolveIdpQueryResult = Apollo.QueryResult<
  ResolveIdpQuery,
  ResolveIdpQueryVariables
>;
